import secureLocalStorage from "react-secure-storage";
import { CircularProgress , RadioGroup} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import { filterBy, orderBy } from "@progress/kendo-data-query";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import { Checkbox } from "@progress/kendo-react-inputs";
import { Popup } from "@progress/kendo-react-popup";
import * as moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import Images from "../../Assets/Images";
import Api from "../../Services/Api";
import "../../Styles/RiskViews.scss";
import ColumnMenuFilter from "../Dashboard/ColumnMenuFilter";
import { CustomFieldSearchMenu } from "../Dashboard/CustomFieldSearchMenu";
import { MitigationDetails } from "../Dashboard/MitigationDetails";
import MitigationViewSelection from "../Dashboard/MitigationViewSelection";
import OrganizationTreeList from "../Dashboard/OrganizationTreeList";
import { SearchMenu } from "../Dashboard/SearchMenu";
import ExistingControlCell from "./Component/ExistingControlCell";
import PrePostComponenant from "./Component/PrePostComponenant";
import RiskCauseCell from "./Component/RiskCauseCell";
import RiskDescriptionCell from "./Component/RiskDescriptionCell";
import RiskColumns from "./RiskColumns.json";
import AddToCart from "./AddToCart";
import ImpactEditComponent from "./Component/ImpactEditComponent";
import { formatNumber } from "@telerik/kendo-intl";
import QualitativeImpactEditComponent from "./Component/QualitativeImpactEditComponent";
import { ColumnMenuCheckboxFilter } from "../Dashboard/ColumnMenuCheckboxFilter";
import { mapTree } from "@progress/kendo-react-treelist";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import TaskDataset from "../Tasks/TaskDataset";
import SubTaskDataset from "../Tasks/SubTaskDataset";

const filterOperators= {
  'text': [
      { text: 'grid.filterContainsOperator', operator: 'contains' },
      { text: 'grid.filterNotContainsOperator', operator: 'doesnotcontain' },
      { text: 'grid.filterEqOperator', operator: 'eq' },
      { text: 'grid.filterNotEqOperator', operator: 'neq' },
      { text: 'grid.filterStartsWithOperator', operator: 'startswith' },
      { text: 'grid.filterEndsWithOperator', operator: 'endswith' },
      { text: 'grid.filterIsNullOperator', operator: 'isnull' },
      { text: 'grid.filterIsNotNullOperator', operator: 'isnotnull' },
      // { text: 'grid.filterIsEmptyOperator', operator: 'isempty' },
      // { text: 'grid.filterIsNotEmptyOperator', operator: 'isnotempty' }
  ],
  'numeric': [
      { text: 'grid.filterEqOperator', operator: 'eq' },
      { text: 'grid.filterNotEqOperator', operator: 'neq' },
      { text: 'grid.filterGteOperator', operator: 'gte' },
      { text: 'grid.filterGtOperator', operator: 'gt' },
      { text: 'grid.filterLteOperator', operator: 'lte' },
      { text: 'grid.filterLtOperator', operator: 'lt' },
      { text: 'grid.filterIsNullOperator', operator: 'isnull' },
      { text: 'grid.filterIsNotNullOperator', operator: 'isnotnull' }
  ],
  'date': [
      { text: 'grid.filterEqOperator', operator: 'eq' },
      { text: 'grid.filterNotEqOperator', operator: 'neq' },
      { text: 'grid.filterAfterOrEqualOperator', operator: 'gte' },
      { text: 'grid.filterAfterOperator', operator: 'gt' },
      { text: 'grid.filterBeforeOperator', operator: 'lt' },
      { text: 'grid.filterBeforeOrEqualOperator', operator: 'lte' },
      { text: 'grid.filterIsNullOperator', operator: 'isnull' },
      { text: 'grid.filterIsNotNullOperator', operator: 'isnotnull' }
  ],
  'boolean': [
      { text: 'grid.filterEqOperator', operator: 'eq' },
  ]
}
export class Datasets extends Component {
  lastSelectedIndex = 0;
  activateFilterDataset = false;
  constructor(props) {
    super(props);
    this.state = {
      riskList: [],
      riskTemp: [],
      finalRiskList:[],
      mitigationData: [],
      taskDataList:[],
      subTaskDataList:[],
      taskDatasetList:[],
      subTaskDatasetList:[],
      selectedTaskIds:[],
      selectedSubTaskIds:[],
      datasourceList: [],
      scope: "1",
      ActiveId: null,
      viewType: "ALL",
      selected: 0,
      widgetTypeList: [],
      widgetTypeListTemp: [],
      createViewDialogopen: false,
      openWidgetCreatePopup: false,
      dashboardList: [],
      timestampXAxisColumns: [],
      riskTypemaster: [],
      loader: false,
      Name: "",
      reportName: "",
      widgetError: {
        widgetName: false,
        widgetChart: false,
        widgetDashboard: false,
        widgetDataSet: false,
        widgetXAxis: false,
        widgetYAxis: false,
      },
      IsTimestamp: false,
      isOpportunities: false,
      FilterStatus: "1D",
      OrgUnitIds: [],
      mitigationFilter: {},
      selectedIds: [],
      selectedActionIds: [],
      IsWorkstreamchanged: false,
      existingFilter: [],
      take: 10,//Math.round((window.innerHeight - 250) / 35),
      skip: 0,
      selectedColumn: undefined,
      customFieldsmaster: [],
      impactMaster: [],
      filter: {
        logic: "and",
        filters: [],
      },
      sort: [],
      showActionDataSet: true,
      showRiskDataSet: true,
      showTaskDataSet: true,
      showSubTaskDataSet: true,
      openDeleteModelFlagView: false,
      editFlag: false,
      MitigationDatasourceList: [],
      MitigationDatasourceListTemp: [],
      riskDatasetList: [],
      riskDatasetListTemp: [],
      widgetNameLists: [],
      isNameExist: false,
      cartViewDetails: {},
      cartViewType: "",
      HeatMapConfigDataOpportunity: [],
      HeatMapConfigDataThreat: [],
      dynamicHeatmapProbabilityRange: [],
      xAxisColumns: [],
      yAxisColumns: [],
      xAxisColumnsListTemp: [],
      yAxisColumnsListTemp: [],
      topBottomList: ["Top", "Bottom"],
      fieldList: [],
      parentFieldList:[],
      dateFieldList: [],
      parentDateFieldList:[],
      actSelectedTopBottom: "",
      actSelectedNumber: 0,
      actSelectedField: null,
      parentSelectedTopBottom:"",
      parentSelectedNumber:0,
      parentSelectedField:"",
      mitigationDataTemp: [],
      impactWithCountCols: [],
      riskTypemasterMiti: [],
      customFieldsmasterMiti: [],
      isCustomFieldDeleted: false,
      isImpactDeleted: false,
      notValidPrimeDataset: false,
      fieldMissingMsg: "",
      primeHideFlag: secureLocalStorage.getItem("isPrime") == true ? true : false,
      // dynamicdatset
      days_value: "",
      parent_days_value:"",
      datefield_value: "",
      parent_datefield_value:"",
      // dynamicdatset
      mode_value: "",
      parent_mode_value: "",
      Mode: ["Forward", "Backward","Back Beyond"],
      date_impact: "None",
      parent_date_impact:"None",
      trendYAxis:[],
      progressStatusFlag:false,
      isSelectAllWorkstream:false,
      isDatasetMode: false,
      parentRiskDatasetList: [],
      parentViewId: 0,
      filteredRiskIds:[],
      parentTaskDatasetList:[],
      filteredTaskIds: []
    };

    this.myRef = React.createRef();
    this.expandChange = this.expandChange.bind(this);
    //For Json serialize purpose
    Date.prototype.toJSON = function () {
      return moment(this).format("YYYY-MM-DDTHH:mm:ss");
    };
  }

  handleSelect = (e) => {
    const newSelectedTab = e;
    this.setState({ selected: newSelectedTab }, () => {
      // After state is updated, load data for the selected tab
      if (newSelectedTab === 0) {
        // Risk tab selected - load Risk and Action data if needed
        if (this.state.viewType === "RISK") {
          // Refresh risk data if we have a view selected
          if (this.state.viewId) {
            const viewData = this.state.riskDatasetList.find(data => data.id === this.state.viewId);
            if (viewData) {
              this.getRiskDataByViewId(viewData);
            }
          }
        } else if (this.state.viewType === "ACTION") {
          // Refresh action data if we have a view selected
          if (this.state.viewId) {
            const viewData = this.state.MitigationDatasourceList.find(data => data.id === this.state.viewId);
            if (viewData) {
              this.getActionDataByViewId(viewData);
            }
          }
        }
        else {
          let viewData = null;
          if (this.state.mitigationData.length > 0) {
            viewData = this.state.mitigationData;
          }
          if (viewData && this.refs.childAction) {
            this.refs.childAction.init();
          }
        }
      } else if (newSelectedTab === 1) {
        // Task tab selected - load Task and Activity data if needed
        if (this.state.viewType === "TASK") {
          if (this.state.viewId) {
            const viewData = this.state.taskDatasetList.find(data => data.id === this.state.viewId);
            if (viewData && this.refs.childTask) {
              this.refs.childTask.getTaskDatasetView(viewData);
            }
          }
        } else if (this.state.viewType === "SUBTASK") {
          // Refresh subtask data if we have a view selected
          if (this.state.viewId) {
            const viewData = this.state.subTaskDatasetList.find(data => data.id === this.state.viewId);
            if (viewData && this.refs.childSubTask) {
              this.refs.childSubTask.getTaskActionDatasetView(viewData);
            }
          }
        }
        else {
          let viewData = null;
          if (this.state.taskDataList.length > 0) {
            viewData = this.state.taskDataList;
          }
          if (viewData && this.refs.childTask) {
            this.refs.childTask.initTask(viewData);
          }
          if (this.state.subTaskDataList.length > 0) {
            viewData = this.state.subTaskDataList;
          }
          if (viewData && this.refs.childSubTask) {
            this.refs.childSubTask.initSubTasks(viewData);
          }
        }
      }
    });
  }
  handleFilteredTaskIds = (ids) => {
    if (ids !== this.state.filteredTaskIds) {
      this.setState({ filteredTaskIds: ids });
    }
  };

  componentDidMount() {
    this.isAuthorizeUse();
  }
  isAuthorizeUse = () => {
    if (!secureLocalStorage.getItem("authToken")) {
      if (this.props.match.params.id) {
        this.props.history.push({
          pathname: `/tenant/${this.props.match.params.id}`,
        });
      } else {
        this.props.history.push({
          pathname: "/",
        });
      }
    } else {
      this.initLoad();
    }
  };
  initLoad = async () => {
    await this.getOrganizationsUnits();
    this.getWidgets();
    this.getRiskTypeList();
    this.getCustomField();
    this.getMitigationViewAxis();
    this.getRiskDataSource();
    this.getMatrixColorCodes();
    this.getTaskDatasetList();
    this.getTaskActionDatasetList();
    
  };

  ToggleTimestamp = (event) => {
    this.setState({ IsTimestamp: event.value });
    let chartList = [];
    if (this.state.viewFlag == "MITI") {
      chartList = this.state.widgetTypeListTemp.filter(
        (item) =>
          item.name !== "HEAT_MAP" &&
          item.name != "MONTE_CARLO" &&
          item.name != "KPI" &&
          item.name != "DATA" &&
          item.name != "TEXT_WIDGET" &&
          item.name != "TRENDING_CHART"
      );
      if (event.value) {
        this.setState({
          xAxisColumnsList: this.state.xAxisColumnsList,
          yAxisColumnsList: this.state.timestampYAxisColumns,
          XAxisValue: {},
          YAxisValue: {},
          IsTimestamp: event.value,
          widgetTypeList: chartList,
        });
      } else {
        this.setState({
          xAxisColumnsList: this.state.xAxisColumnsList,
          yAxisColumnsList: this.state.timestampYAxisColumns,
          XAxisValue: {},
          YAxisValue: {},
          IsTimestamp: event.value,
          widgetTypeList: this.state.widgetTypeListTemp,
        });
      }
    } else {
      let arr = this.state.timestampXAxisColumns.filter(
        (item) => item.type !== "CustomField"
      );

      chartList = this.state.widgetTypeListTemp.filter(
        (item) =>
          item.name !== "BURN_DOWN_CHART" &&
          item.name != "MONTE_CARLO" &&
          item.name != "KPI" &&
          item.name != "DATA" &&
          item.name != "TEXT_WIDGET"&&
          item.name != "TRENDING_CHART"
      );

      if (event.value) {
        this.setState({
          xAxisColumnsList: arr,
          yAxisColumnsList: this.state.timestampYAxisColumns,
          XAxisValue: {},
          YAxisValue: {},
          IsTimestamp: event.value,
          widgetTypeList: chartList,
        });
      } else {
        this.setState({
          xAxisColumnsList: arr,
          yAxisColumnsList: this.state.timestampYAxisColumns,
          XAxisValue: {},
          YAxisValue: {},
          IsTimestamp: event.value,
          widgetTypeList: this.state.widgetTypeListTemp,
        });
      }
    }
  };

  customDateFilter = (event) => {
    this.state = { ...this.state, FilterStatus: "" };
    var rangeDate = Object.create(event.value);
    var sDate = rangeDate.start;
    var eDate = rangeDate.end;
    if (sDate && eDate) {
      var startDate = new Date(sDate.setDate(sDate.getDate() + 1));
      var endDate = new Date(eDate.setDate(eDate.getDate() + 1));

      this.setState({
        ...this.state,
        FilterStatus: "",
        startDate: startDate,
        endDate: endDate,
      });
      sDate.setDate(sDate.getDate() - 1);
      eDate.setDate(eDate.getDate() - 1);
    }
  };

  getRiskDataByViewId = async (viewData) => {
    try {
      console.log("viewData", viewData);
      var loggedClient = secureLocalStorage.getItem("loggedClient");
      var createdby =
        loggedClient === "user"
          ? secureLocalStorage.getItem("userId")
          : secureLocalStorage.getItem("tenantId");
      const requestParams = {
        ViewId: viewData.id,
        CreatedBy: parseInt(createdby),
        IsFromDataset: true
      };
      this.setState({
        ...this.state,
        riskList: [],
        finalRiskList:[],
        loader: true,
        viewType: "RISK",
        take: 10,//Math.round((window.innerHeight - 250) / 35),
        skip: 0,
        existingFilter: [],
        sort: [],
        filter: {
          logic: "and",
          filters: [],
        },
      });
      let result = await Api.getByViewId(requestParams);

      if (result.status === 200) {
        if (
          result.isCustomFieldDeleted ||
          result.isImpactDeleted ||
          result.notValidPrimeDataset
        ) {
          this.setState({
            ...this.state,
            selectedOrgUnit: [],
            OrgUnitIds: [],
            riskList: [],
            finalRiskList:[],
            riskTemp: [],
            isCustomFieldDeleted: result.isCustomFieldDeleted,
            isImpactDeleted: result.isImpactDeleted,
            notValidPrimeDataset: result.notValidPrimeDataset,
            isSelectAllWorkstream: result.isSelectAllWorkstream,
            loader: this.state.viewFlag != "ACTION"? false : true,
          });
          return;
        }
        let response = await this.getRiskListByOrgUnitIdsNew(result.orgUnitIds);
        let impactMaster = [];
        var selectedOrgUnitArray = [];
        response.riskRegister.map((riskReg) => {
          if (!riskReg.organizationUnitName) {
            riskReg.organizationUnitName = null;
          }
          if (!riskReg.number) {
            riskReg.number = null;
          }
          if (!riskReg.riskTitle) {
            riskReg.riskTitle = null;
          }
          if (!riskReg.isOpportunity) {
            riskReg.isOpportunity = null;
          }
          if (!riskReg.name) {
            riskReg.name = null;
          }
          if (!riskReg.cause) {
            riskReg.cause = null;
          }
          if (!riskReg.existingControl) {
            riskReg.existingControl = null;
          }
          if (!riskReg.impactComments) {
            riskReg.impactComments = null;
          }

          if (!riskReg.owner) {
            riskReg.owner = null;
          }

          if (!riskReg.updatedBy) {
            riskReg.updatedBy = null;
          }
          if (riskReg.proximityDate) {
            riskReg.proximityDate = new Date(riskReg.proximityDate);
          } else {
            riskReg.proximityDate = null;
          }
          if (riskReg.closedDate) {
            riskReg.closedDate = new Date(riskReg.closedDate);
          } else {
            riskReg.closedDate = null;
          }
          if (riskReg.updatedDate) {
            var time = moment(riskReg.updatedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let updatedDate = time;
            riskReg.updatedDate = riskReg.updatedDate
              ? new Date(updatedDate)
              : "";
          } else {
            riskReg.updatedDate = null;
          }
          if (riskReg.createdDate) {
            var time = moment(riskReg.createdDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let createdDate = time;
            riskReg.createdDate = riskReg.createdDate
              ? new Date(createdDate)
              : "";
          } else {
            riskReg.createdDate = null;
          }

          selectedOrgUnitArray.push(riskReg.organizationUnitId);

          if (riskReg.riskTypeNames && riskReg.riskTypeNames.length > 0) {
            let hashArr = this.stringToHash(
              riskReg.riskTypeNames.toString(),
              "riskTypeNames"
            );

            riskReg["riskTypeNames"] = hashArr;
          } else {
            riskReg["riskTypeNames"] = "undefined";
          }
          if (riskReg.isClosed) {
            riskReg.isClosed = "Open";
          } else {
            riskReg.isClosed = "Closed";
          }
          if (riskReg && riskReg.impactResponse) {
            impactMaster = riskReg.impactResponse;
          }
        });

        this.setState({ ...this.state, impactMaster: impactMaster });
        await this.createDynamicDropdowns(response.riskRegister);
        await this.createDynamicCols(response.riskRegister);

        this.setState({
          ...this.state,
          selectedOrgUnit: selectedOrgUnitArray,
          OrgUnitIds: Array.from(new Set(selectedOrgUnitArray)),
          riskList: response.riskRegister,
          riskTemp: response.riskRegister,
          isCustomFieldDeleted: result.isCustomFieldDeleted,
          isImpactDeleted: result.isImpactDeleted,
          isSelectAllWorkstream: result.isSelectAllWorkstream,
          // loader: false,
        });
        //Filter
        if (result.isFiltered && result.filterQuery) {
          let parsedData = JSON.parse(result.filterQuery);
          if (parsedData && parsedData !== "{}") {
            let val = JSON.parse(parsedData);
            await this.clearFilterNew(val);
          } else {
            this.setState(
              {
                ...this.state,
                riskList: response.riskRegister,
                isSelectAllWorkstream: result.isSelectAllWorkstream,
              },
              () => {
                console.log("-");
              }
            );
          }
        }

        //CheckBox
        var riskData = [];
        if (!result.isFiltered) {
          result.riskRegister.map((_risk) => {
            let index = this.state.riskList.findIndex(
              (d) => d.riskRegisterId === _risk.riskRegisterId
            );
            if (index != -1) {
              riskData.push(this.state.riskList[index]);
            }
          });
          riskData = riskData.map((dataItem) =>
            Object.assign({ selected: true }, dataItem)
          );
        } else {
          riskData = this.state.riskList;
        }
        this.setState({
          ...this.state,
          riskList: riskData,
          isSelectAllWorkstream: result.isSelectAllWorkstream,
        });
        this.refs.child.refreshData(Array.from(new Set(selectedOrgUnitArray)));
        if(result.isSelectAllWorkstream){
          let wsIds=[];
          mapTree(this.state.data, "children", (item) => {
            wsIds.push(item.unitId);
            return item;
          });
          this.refs.child.refreshData(wsIds);
        }else{
          this.refs.child.refreshData(Array.from(new Set(selectedOrgUnitArray)));
        }
      } else {
        this.refs.child.refreshData([]);
        this.setState({
          ...this.state,
          riskList: [],
          selectedOrgUnit: [],
          riskTemp: [],
          isSelectAllWorkstream: result.isSelectAllWorkstream,
        });
      }
      //Top-X
      // dynamicdatset-modification in if condition

      if (
        (result.isFiltered &&
          viewData.field &&
          viewData.topOrBottom &&
          viewData.topOrBottomCount) ||
        (viewData.topxDateMode &&
          viewData.topxDateField &&
          viewData.topxDateCount)||
          (viewData.topxDateMode &&
            viewData.topxDateField &&
            viewData.topxDateCount===0)
      ) {
        let tempResult = [];
        if (
          result.riskRegister &&
          result.riskRegister.length > 0 &&
          this.state.riskList.length > 0
        ) {
          result.riskRegister.map((_risk) => {
            let index = this.state.riskList.findIndex(
              (d) => d.riskRegisterId === _risk.riskRegisterId
            );
            if (index != -1) {
              tempResult.push(this.state.riskList[index]);
            }
          });
        }
        this.setState({
          ...this.state,
          riskList: tempResult,
          isSelectAllWorkstream: result.isSelectAllWorkstream,
        });
        setTimeout(() => {
          this.setState({
            ...this.state,
            loader: this.state.viewFlag != "ACTION"? false : true,
            isSelectAllWorkstream: result.isSelectAllWorkstream,
          });
        }, 1000);
      } else {
        setTimeout(() => {
          this.setState({
            ...this.state,
            loader: this.state.viewFlag != "ACTION"? false : true,
            isSelectAllWorkstream: result.isSelectAllWorkstream,

          });
        }, 1000);
      }
    } catch (error) {
      console.log(error);
      this.setState({ ...this.state, loader: false });
    }
  };

  checkRisktypeSelections = (exfilter) => {
    let temp = [];
    this.state.riskTypemaster.map((item) => {
      let checked = this.checkCFinFilterValuesOrNot(
        "riskTypeNames",
        item.hashValue,
        exfilter
      );
      item["checked"] = checked;
      temp.push(item);
    });
    this.setState({ ...this.state, riskTypemaster: temp });
  };

  getActionDataByViewId = async (viewData) => {
    try {
      if (this.refs.childAction) {
        this.refs.childAction.updateFilter();
      }
      var loggedClient = secureLocalStorage.getItem("loggedClient");
      var createdby =
        loggedClient === "user"
          ? secureLocalStorage.getItem("userId")
          : secureLocalStorage.getItem("tenantId");
      const requestParams = {
        ViewId: viewData.id,
        CreatedBy: parseInt(createdby),
        IsFromDataset: true
      };

      this.setState({
        ...this.state,
        loader: true,
        viewType: "ACTION",
        take: 10,//Math.round((window.innerHeight - 250) / 35),
        skip: 0,
        mitigationFilter: [],
        mitigationData: [],
      });
      let result = await Api.getMitigationFromView(requestParams);
      if (result.status === 200) {
        if (result.isCustomFieldDeleted || result.isImpactDeleted) {
          this.setState(
            {
              ...this.state,
              loader: false,
              mitigationData: [],
              mitigationDataTemp: [],
              OrgUnitIds: [],
              isCustomFieldDeleted: result.isCustomFieldDeleted,
              isImpactDeleted: result.isImpactDeleted,
              isSelectAllWorkstream: result.isSelectAllWorkstream,
            },
            () => {}
          );

          return;
        }

        let response = await this.getMitigationByDataByOrgIdsNew(
          result.orgunitIds
        );

        response.riskMitigationResponse.map((riskReg) => {
          if (!riskReg.organisationName) {
            riskReg.organisationName = null;
          }
          if (!riskReg.riskNumber) {
            riskReg.riskNumber = null;
          }
          if (!riskReg.riskName) {
            riskReg.riskName = null;
          }
          if (!riskReg.isOpportunity) {
            riskReg.isOpportunity = null;
          }
          if (!riskReg.name) {
            riskReg.name = null;
          }
          if (!riskReg.number) {
            riskReg.number = null;
          }
          if (!riskReg.control) {
            riskReg.control = null;
          }
          if (!riskReg.externalReference) {
            riskReg.externalReference = null;
          }
          if (!riskReg.actionType) {
            riskReg.actionType = null;
          }
          if (!riskReg.owner) {
            riskReg.owner = null;
          }
          if (!riskReg.updatedBy) {
            riskReg.updatedBy = null;
          }
          if (riskReg.actualCompletionDate) {
            riskReg.actualCompletionDate = new Date(
              riskReg.actualCompletionDate
            );
          } else {
            riskReg.actualCompletionDate = null;
          }
          if (riskReg.originalCompletionDate) {
            riskReg.originalCompletionDate = new Date(
              riskReg.originalCompletionDate
            );
          } else {
            riskReg.originalCompletionDate = null;
          }
          if (riskReg.projectedCompletionDate) {
            riskReg.projectedCompletionDate = new Date(
              riskReg.projectedCompletionDate
            );
          } else {
            riskReg.projectedCompletionDate = null;
          }
          if (riskReg.proximityDate) {
            riskReg.proximityDate = new Date(riskReg.proximityDate);
          } else {
            riskReg.proximityDate = null;
          }
          if (riskReg.closedDate) {
            riskReg.closedDate = new Date(riskReg.closedDate);
          } else {
            riskReg.closedDate = null;
          }
          if (riskReg.updatedDate) {
            var time = moment(riskReg.updatedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let updatedDate = time;
            riskReg.updatedDate = riskReg.updatedDate
              ? new Date(updatedDate)
              : "";
          } else {
            riskReg.updatedDate = null;
          }
          if (riskReg.createdDate) {
            var time = moment(riskReg.createdDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let createdDate = time;
            riskReg.createdDate = riskReg.createdDate
              ? new Date(createdDate)
              : "";
          } else {
            riskReg.createdDate = null;
          }

          if (riskReg.riskTypeNames && riskReg.riskTypeNames.length > 0) {
            let hashArr = this.stringToHash(
              riskReg.riskTypeNames.toString(),
              "riskTypeNames"
            );

            riskReg["riskTypeNames"] = hashArr;
          } else {
            riskReg["riskTypeNames"] = "undefined";
          }
          riskReg["spi"] = parseInt(riskReg.spi);
          riskReg["percentageCompletion"] = parseInt(
            riskReg.percentageCompletion
          );
          if (riskReg.isOpen) {
            riskReg.isOpen = "Open";
          } else {
            riskReg.isOpen = "Close";
          }
          if (riskReg.approved) {
            riskReg.approved = "Yes";
          } else {
            riskReg.approved = "No";
          }
        });
        //Checkbox Dataset
        var riskMitigationResponse = [];
         if (!result.isFiltered) {
          result.riskMitigationResponse.map((_risk) => {
            let index = response.riskMitigationResponse.findIndex(
              (d) => d.riskRegisterActionId === _risk.riskRegisterActionId
            );
            if (index != -1) {
              riskMitigationResponse.push(
                response.riskMitigationResponse[index]
              );
            }
          });
          riskMitigationResponse = riskMitigationResponse.map((dataItem) =>
            Object.assign({ selected: true }, dataItem)
          );
        } else {
          riskMitigationResponse = response.riskMitigationResponse;
        }

        this.setState(
          {
            ...this.state,
            // loader: false,
            mitigationData: riskMitigationResponse,
            mitigationDataTemp: response.riskMitigationResponse,
            OrgUnitIds: result.orgunitIds,
            isCustomFieldDeleted: result.isCustomFieldDeleted,
            isImpactDeleted: result.isImpactDeleted,
            isSelectAllWorkstream:response.isSelectAllWorkstream
          },
          () => {}
        );
        //Filter
        if (
          result.isFiltered &&
          result.filterQuery &&
          !viewData.field &&
          !viewData.topOrBottom &&
          !viewData.topOrBottomCount
        ) {
          let parsedData = JSON.parse(result.filterQuery);
          if (parsedData && parsedData !== "{}") {
            let val = JSON.parse(parsedData);
            setTimeout(() => {
              this.refs.childAction.clearFilterNew(val);
            }, 1000);
          } else if (parsedData && parsedData == "{}") {
            setTimeout(() => {
              this.refs.childAction.clearFilterNew([]);
            }, 1000);
          }
        }
        this.refs.child.refreshData(result.orgunitIds);
        if(result.isSelectAllWorkstream){
          let wsIds=[];
          mapTree(this.state.data, "children", (item) => {
            wsIds.push(item.unitId);
            return item;
          });
          this.refs.child.refreshData(wsIds);
        }else{
          this.refs.child.refreshData(result.orgunitIds);
        }
      } else {
        this.setState({
          ...this.state,
          mitigationData: [],
          mitigationDataTemp: [],
          OrgUnitIds: [],
          isSelectAllWorkstream: result.isSelectAllWorkstream,
        });
      }
      // Top - x
      // dynamicdatset-modifiction in if condition
      if (
        (result.isFiltered &&
          viewData.field &&
          viewData.topOrBottom &&
          viewData.topOrBottomCount) ||
        (viewData.topxDateMode &&
          viewData.topxDateField &&
          viewData.topxDateCount)||(viewData.topxDateMode &&
            viewData.topxDateField &&
            viewData.topxDateCount===0)
      ) {
        let parsedData = JSON.parse(result.filterQuery);
        if (parsedData && parsedData !== "{}" && parsedData !== "[]") {
          let val = JSON.parse(parsedData);
          setTimeout(() => {
            this.refs.childAction.clearFilterNew(val);
          }, 1000);
        } else if (parsedData && parsedData == "{}" && parsedData == "[]") {
          setTimeout(() => {
            this.refs.childAction.clearFilterNew([]);
          }, 1000);
        }

        let tempResult = [];
        if (
          result.riskMitigationResponse &&
          result.riskMitigationResponse.length > 0 &&
          this.state.mitigationData.length > 0
        ) {
          result.riskMitigationResponse.map((_risk) => {
            let index = this.state.mitigationData.findIndex(
              (d) => d.riskRegisterActionId === _risk.riskRegisterActionId
            );
            if (index != -1) {
              tempResult.push(this.state.mitigationData[index]);
            }
          });
        }

        setTimeout(() => {
          this.setState({
            ...this.state,
            loader: false,
            mitigationData: tempResult,
            isSelectAllWorkstream: result.isSelectAllWorkstream,
          });
        }, 1000);
      } else {
        setTimeout(() => {
          this.setState({
            ...this.state,
            loader: false,
            isSelectAllWorkstream: result.isSelectAllWorkstream,
          });
        }, 1000);
      }
      // ends
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };

  createWidgetdClose = () => {
    this.setState({
      widgetError: {
        widgetName: false,
        widgetChart: false,
        widgetDashboard: false,
        widgetDataSet: false,
        widgetXAxis: false,
        widgetYAxis: false,
      },

      openWidgetCreatePopup: false,
      reportName: "",
      dashboard: "",
      datasource: null,
      XAxisValue: "",
      YAxisValue: "",
      WidgetTypeId: "",
      ActiveId: "",
    });
  };

  getWidgets = async (viewFlag) => {
    try {
      let response = await Api.getWidgetType();

      if (response.status === 200) {
        if (viewFlag === "MITI") {
          var list = response.widgetTypes
            ? response.widgetTypes.filter(
                (item) =>
                  item.name !== "HEAT_MAP" &&
                  item.name != "MONTE_CARLO" &&
                  item.name != "KPI"
              )
            : [];
          this.setState({
            ...this.state,
            widgetTypeList: list,
            widgetTypeListTemp: list,
          });
        } else {
          let list = response.widgetTypes.filter(
            (item) => item.name !== "BURN_DOWN_CHART"
          );
          this.setState({
            ...this.state,
            widgetTypeList: list,
            widgetTypeListTemp: list,
          });
        }
      } else {
        this.setState({ ...this.state, widgetTypeList: [] });
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, widgetTypeList: [], loader: false });
    }
  };
  selectWidget = (item) => {
    this.setState({
      ...this.state,
      WidgetTypeId: item.widgetTypeId,
      ActiveId: item.widgetTypeId,
      widgetName: item.name,
      XAxisValue: {},
      YAxisValue: {},
    });
    this.setState((prevState) => ({
      widgetError: {
        ...prevState.widgetError,
        widgetChart: false,
      },
    }));
  };

  getDashboardWithWidgetName = async () => {
    try {
      var loggedClient = secureLocalStorage.getItem("loggedClient");
      var createdby =
        loggedClient === "user"
          ? secureLocalStorage.getItem("userId")
          : secureLocalStorage.getItem("tenantId");
      var request = {
        CreatedBy: parseInt(createdby),
      };
      let response = await Api.getDashboard(request);
      if (response.status === 200 && response.dashBoards) {
        let widgetNameLists = [];
        if (response.dashBoards) {
          response.dashBoards.map((item) => {
            if (item.widgetCols) {
              item.widgetCols.map((wid) => {
                widgetNameLists.push(wid.name.toLowerCase());
              });
            }
          });
        }
        this.setState({
          ...this.state,
          widgetNameLists: widgetNameLists,
        });
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };
  getDashboard = async () => {
    try {
      var loggedClient = secureLocalStorage.getItem("loggedClient");
      var createdby =
        loggedClient === "user"
          ? secureLocalStorage.getItem("userId")
          : secureLocalStorage.getItem("tenantId");
      var request = {
        CreatedBy: parseInt(createdby),
      };
      this.state = { ...this.state, loader: true };
      let response = await Api.getDashBoardList(request);
      if (response.status === 200 && response.dashBoards) {
        this.setState({
          ...this.state,
          loader: false,
          dashboardList: response.dashBoards,
        });
      } else {
        this.setState({
          ...this.state,
          loader: false,
          dashboardList: [],
        });
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };

  getDataSource = async (viewFlag) => {
    try {
      var loggedClient = secureLocalStorage.getItem("loggedClient");
      var createdby =
        loggedClient === "user"
          ? secureLocalStorage.getItem("userId")
          : secureLocalStorage.getItem("tenantId");
      var request = {
        CreatedBy: parseInt(createdby),
        Type: viewFlag === "MITI" ? "Mitigation" : "Risk",
      };
      this.state = { ...this.state, loader: true };
      let response =
        viewFlag === "MITI"
          ? await Api.getMitigationViewAxis(request)
          : await Api.getView(request);
      if (response.status === 200) {
        const heatmapCols = response.yAxisColumns.filter(
          (task) =>
            task.colsName !== "Frequency" && task.colsName !== "MitigationCount"
        );
        this.setState({
          ...this.state,
          datasourceList: response.datasource,
          xAxisColumnsList: response.xAxisColumns,
          yAxisColumnsList: response.yAxisColumns,
          xAxisColumnsListTemp: response.xAxisColumns,
          yAxisColumnsListTemp: response.yAxisColumns,
          timestampXAxisColumns: response.timestampXAxisColumns,
          timestampYAxisColumns: response.timestampYAxisColumns,
          loader: false,
        });
      } else {
        this.setState({ ...this.state, loader: false });
        this.setState({ ...this.state, data: [] });
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };

  getChatImage = (img) => {
    var chartImg = "";
    if (img === "BARCHART") {
      chartImg = Images.BARCHART;
    } else if (img === "DOUGHNUTCHART") {
      chartImg = Images.DOUGHNUTCHART;
    } else if (img === "BUBBLECHART") {
      chartImg = Images.BUBBLECHART;
    } else if (img === "TEXTWIDGET") {
      chartImg = Images.TEXT;
    } else if (img === "KPI") {
      chartImg = Images.VIEWLIST;
    } else if (img === "PIECHART") {
      chartImg = Images.PIECHART;
    } else if (img === "GRIDCHART") {
      chartImg = Images.GRIDCHART;
    } else if (img === "LINECHART") {
      chartImg = Images.LINECHART;
    } else if (img === "AREACHART") {
      chartImg = Images.AREACHART;
    } else if (img === "HEATMAP") {
      chartImg = Images.HEATMAP;
    } else if (img === "BURNDOWNCHART") {
      chartImg = Images.AREACHART;
    } else if (img === "HISTOGRAM") {
      chartImg = Images.DASHBOARDICON;
    } else if (img === "DATA") {
      chartImg = Images.VIEWDATA;
    } else if (img === "TRENDINGCHART") {
      chartImg = Images.GAUGECHART;
    }
    return chartImg;
  };
  handleValidationWidget = () => {
    let widgetValidationName = false;
    let widgetValidationDashboard = false;
    let widgetValidationType = false;
    let widgetValidationXAxis = false;
    let widgetValidationYAxis = false;
    let widgetValidationDatasource = false;
    if (this.state.reportName && this.state.reportName.trim() != "") {
      this.setState((prevState) => ({
        widgetError: {
          ...prevState.widgetError,
          widgetName: false,
        },
      }));
      widgetValidationName = false;
    } else {
      this.setState((prevState) => ({
        widgetError: {
          ...prevState.widgetError,
          widgetName: true,
        },
      }));
      widgetValidationName = true;
    }
    if (this.state.dashboard) {
      this.setState((prevState) => ({
        widgetError: {
          ...prevState.widgetError,
          widgetDashboard: false,
        },
      }));
      widgetValidationDashboard = false;
    } else {
      this.setState((prevState) => ({
        widgetError: {
          ...prevState.widgetError,
          widgetDashboard: true,
        },
      }));
      widgetValidationDashboard = true;
    }
    if (this.state.WidgetTypeId) {
      this.setState((prevState) => ({
        widgetError: {
          ...prevState.widgetError,
          widgetChart: false,
        },
      }));
      widgetValidationType = false;
    } else {
      this.setState((prevState) => ({
        widgetError: {
          ...prevState.widgetError,
          widgetChart: true,
        },
      }));
      widgetValidationType = true;
    }
    if (this.state.widgetName !== "TEXT_WIDGET") {
      if (this.state.datasource && this.state.datasource.length !== 0) {
        this.setState((prevState) => ({
          widgetError: {
            ...prevState.widgetError,
            widgetDataSet: false,
          },
        }));
        widgetValidationDatasource = false;
      } else {
        if (
          this.state.widgetName !== "HEAT_MAP" &&
          this.state.widgetName != "MONTE_CARLO"
        ) {
          this.setState((prevState) => ({
            widgetError: {
              ...prevState.widgetError,
              widgetDataSet: true,
            },
          }));
          widgetValidationDatasource = true;
        }
      }
      if (
        this.state.widgetName !== "BURN_DOWN_CHART" &&
        this.state.widgetName !== "DATA" &&
        this.state.widgetName !== "KPI" &&
        this.state.widgetName !== "TRENDING_CHART"
      ) {
        if (
          this.state.XAxisValue &&
          Object.keys(this.state.XAxisValue).length !== 0
        ) {
          this.setState((prevState) => ({
            widgetError: {
              ...prevState.widgetError,
              widgetXAxis: false,
            },
          }));
          widgetValidationXAxis = false;
        } else {
          this.setState((prevState) => ({
            widgetError: {
              ...prevState.widgetError,
              widgetXAxis: true,
            },
          }));
          widgetValidationXAxis = true;
        }
        if (
          this.state.YAxisValue &&
          Object.keys(this.state.YAxisValue).length !== 0
        ) {
          this.setState((prevState) => ({
            widgetError: {
              ...prevState.widgetError,
              widgetYAxis: false,
            },
          }));
          widgetValidationYAxis = false;
        } else {
          if (
            this.state.widgetName !== "HEAT_MAP" &&
            this.state.widgetName != "MONTE_CARLO"
          ) {
            this.setState((prevState) => ({
              widgetError: {
                ...prevState.widgetError,
                widgetYAxis: true,
              },
            }));
            widgetValidationXAxis = true;
          }
        }
      }
    }

    if (
      widgetValidationName ||
      widgetValidationType ||
      widgetValidationXAxis ||
      widgetValidationYAxis ||
      widgetValidationDashboard ||
      widgetValidationDatasource
    ) {
      return false;
    } else {
      return true;
    }
  };

  saveWidget = async () => {
    if (this.handleValidationWidget()) {
      try {
        this.setState({ ...this.state, loader: true });

        var sDate = this.state.startDate;
        var eDate = this.state.endDate;

        var startDate = sDate
          ? moment(sDate).format("YYYY-MM-DDTHH:mm:ss")
          : undefined;
        var endDate = eDate
          ? moment(eDate).format("YYYY-MM-DDTHH:mm:ss")
          : undefined;
        if (this.state.IsTimestamp && new Date(startDate) > new Date(endDate)) {
          endDate = sDate
            ? moment(sDate).format("YYYY-MM-DDTHH:mm:ss")
            : undefined;
          startDate = eDate
            ? moment(eDate).format("YYYY-MM-DDTHH:mm:ss")
            : undefined;
        }
        let impactId = 0;
        let trendImpactType = null;
        if (this.state.widgetName == "TRENDING_CHART") {
          // let obj = this.state.trendYAxis.find(
          //   (item) => item.impactId === this.state.YAxisValue.impactId
          // );
          // if (obj) {
            impactId = this.state.YAxisValue.impactId;
            trendImpactType = this.state.YAxisValue.type;
          // }
        }
        
        var request = {
          Name: this.state.reportName,
          WidgetTypeId: this.state.WidgetTypeId,
          DashBoardId: this.state.dashboard.dashBoardId,
          DataSource:
            this.state.datasource && this.state.datasource.id
              ? [this.state.datasource.id]
              : [0],
          WidgetAxis: {
            XAxisValue: [this.state.XAxisValue],
            YAxisValue:
              this.state.widgetName !== "HEAT_MAP" &&
              this.state.widgetName != "MONTE_CARLO"
                ? [this.state.YAxisValue]
                : [],
          },
          CreatedDate: new Date(),
          IsTimestamp: this.state.IsTimestamp,
          isOpportunities: this.state.isOpportunities,
          startDate: startDate,
          endDate: endDate,
          title: this.state.title,
          description: this.state.description,
          CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
          trendFromDate:this.state.widgetName == "TRENDING_CHART" ? startDate:undefined,
          trendToDate:this.state.widgetName == "TRENDING_CHART" ? endDate:undefined,
          impactId:impactId,
          trendImpactType:trendImpactType,
        };

        let response = await Api.saveWidget(request);
        if (response.status === 200) {
          toastr.success(response.message);
          this.goToReport(this.state.dashboard.dashBoardId);
          this.createWidgetdClose();
          this.setState({ ...this.state, loader: false });
        } else {
          toastr.error(response.message);
          this.setState({ ...this.state, loader: false });
        }
      } catch (error) {
        console.error(error);
        this.setState({ ...this.state, loader: false });
      }
    }
  };

  createAppState = (dataState) => {
    if (this.state && this.state.riskTemp) {
      return {
        riskList: this.state.riskTemp.slice(0),
        dataState: dataState,
      };
    } else {
      return {
        riskList: [],
        dataState: dataState,
      };
    }
  };

  dataStateChange = (event) => {
    this.setState(this.createAppState(event.dataState));
  };

  setClassName = (field) => {
    let headerClassName = "";
    if (this.state.filter && this.state.filter.filters) {
      this.state.filter.filters.map((filter) => {
        if (filter.field === field) {
          headerClassName = "active";
        }
        if (filter.filters) {
          filter.filters.map((innerFilter) => {
            if (innerFilter.field === field) {
              headerClassName = "active";
            }
          });
        }
      });
    }
    return headerClassName;
  };

  filterSelectedData = (_list) => {
    return _list.filter((item) => item.selected === true);
  };

  getAllImpactThresholdForDataset = async (_type) => {
    try {
      var req = {
        workstreamId: this.state.OrgUnitIds,
      };
      let response = await Api.GetAllImpactThresholdForDataset(_type, req);
      // get dropdown for normal field
      if (response.status === 200 && response.impact) {
        if(_type === "risk"){
        this.setState({ parentFieldList: response.impact });
        }
        else{
          this.setState({ fieldList: response.impact });
        }
      } else {
        this.setState({ ...this.state, fieldList: [], parentFieldList: [] });
      }
      // get dropdown for date fields
      if (response.status === 200 && response.dateDropdownList) {
        if(_type === "risk"){
        this.setState({ parentDateFieldList: response.dateDropdownList });
        }
        else{
          this.setState({ dateFieldList: response.dateDropdownList });
        }
      } else {
        this.setState({ ...this.state, dateFieldList: [], parentDateFieldList:[] });
      }
    } catch (error) {
      console.log(error);
    }
  };

  
  getFieldsForDataset = async (_type) => {
    try {
      var req = {
        workstreamId: this.state.OrgUnitIds,
      };
      let response = await Api.getFieldsForDataset(_type,req);
      // get dropdown for normal field
      if (response.status === 200 && response.topXFields) {
        if(_type === "Task"){
        this.setState({ parentFieldList: response.topXFields });
        }
        else{
        this.setState({ fieldList: response.topXFields });
        }
      } else {
        this.setState({ ...this.state, fieldList: [],  parentFieldList: [] });
      }
      // get dropdown for date fields
      if (response.status === 200 && response.dateDropdownList) {
        if(_type === "Task"){
        this.setState({ parentDateFieldList: response.dateDropdownList });
        }
        else{
        this.setState({ dateFieldList: response.dateDropdownList });
        }
      } else {
        this.setState({ ...this.state, dateFieldList: [], parentDateFieldList:[] });
      }
    } catch (error) {
      console.log(error);
    }
  };

  handleClickOpen = async (viewFlag) => {
    let temp = [];
    if (viewFlag === "RISK") {
      temp = this.filterSelectedData(this.state.riskList);
      this.getAllImpactThresholdForDataset("risk");
      if (temp.length === 0) {
        this.activateFilterDataset = true;
      } else {
        this.activateFilterDataset = false;
      }
    } else if (viewFlag === "MITI") {
      this.getAllImpactThresholdForDataset("action");
      if (this.state.selectedActionIds.length === 0) {
        this.activateFilterDataset = true;
      } else {
        this.activateFilterDataset = false;
      }
    }else if (viewFlag === "TASK") {
      this.getFieldsForDataset("Task");
      if(this.state.selectedTaskIds.length>0){
        this.activateFilterDataset = false;
      }else{
        this.activateFilterDataset = true;
      }
      
    }else if (viewFlag === "SUBTASK") {
      this.getFieldsForDataset("TaskAction");
      if(this.state.selectedSubTaskIds.length>0){
        this.activateFilterDataset = false;
      }else{
        this.activateFilterDataset = true;
      }
    }
    
    if (this.state.editFlag) {
      this.setState({
        ...this.state,
        createViewDialogopen: true,
        Name: this.state.Name,
        description: this.state.description,
        actSelectedTopBottom: this.state.actSelectedTopBottom,
        actSelectedNumber: this.state.actSelectedNumber,
        actSelectedField: this.state.actSelectedField,
        scope: "1",
        viewFlag: viewFlag,
      });
    } else {
      this.setState({
        ...this.state,
        createViewDialogopen: true,
        Name: "",
        scope: "0",
        description: "",
        actSelectedTopBottom: "",
        actSelectedNumber: 0,
        actSelectedField: "",
        viewFlag: viewFlag,
      });
    }
  };

  startCreateDataset = async (type) => {
    await new Promise(resolve => {
      this.setState({
        isDatasetMode: true,
        editFlag: false,
        viewType: type,
        viewFlag: type,
      }, resolve);
    });

    this.myRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });

    if (type === "RISK") await this.getAllImpactThresholdForDataset("risk");
    if (type === "ACTION") {
      await Promise.all([
      this.getAllImpactThresholdForDataset("risk"),
      this.getAllImpactThresholdForDataset("action")
    ]);
    }
    if (type === "TASK") await this.getFieldsForDataset("Task");
    if (type === "SUBTASK"){ 
      await Promise.all([
      await this.getFieldsForDataset("Task"),
      await this.getFieldsForDataset("TaskAction")
      ]);
    }
  };


  handleClose = () => {
    if (this.state.editFlag) {
      this.setState({
        ...this.state,
        createViewDialogopen: false,
        scope: "0",
      });
    } else {
      this.setState({
        ...this.state,
        createViewDialogopen: false,
        Name: "",
        scope: "0",
        date_impact: "None",
        mode_value: "",
        days_value: "",
        datefield_value: "",
        actSelectedTopBottom: "",
        actSelectedNumber: 0,
        actSelectedField: "",
      });
    }
  };

  changeCheckBoxValues = async (filterData) => {
    if (filterData && filterData.length > 0) {
      filterData[0].filters.map((filter) => {
        if (filter.field === "riskTypeNames") {
          let originalValue = this.state.riskTypemaster.find(
            (item) => item.hashValue === filter.tempVal
          );
          if (originalValue) {
            filter["strValue"] =
              originalValue.name === "" ||
              originalValue.name === " [blank]" ||
              originalValue.name === "undefined"
                ? null
                : originalValue.name;
            filter["operators"] = "eq";
          }
        } else if (this.isCustomField(filter.field)) {
          let tt = this.state.customFieldsmaster.find(
            (item) => item.fieldName === filter.field
          );
          if (tt) {
            let originalValue = tt.cfPossibleValues.find(
              (temp) => temp.hashValue === filter.tempVal
            );
            if (originalValue) {
              filter["strValue"] =
                originalValue.possibleValues === " [blank]" ||
                originalValue.possibleValues === "" ||
                originalValue.possibleValues === "undefined"
                  ? null
                  : originalValue.possibleValues;
              filter["operators"] = "eq";
            }
          }
        }
      });
    }
  };

  isCustomField = (field) => {
    let flag = false;
    if (RiskColumns.hasOwnProperty(field)) {
      flag = false;
    } else {
      let tt = this.state.customFieldsmaster.find(
        (item) => item.fieldName === field
      );
      if (tt) {
        flag = true;
      } else {
        let temp = this.state.impactMaster.find((item) => item.name === field);
        if (temp) {
          flag = false;
        }
      }
    }
    return flag;
  };
 
  constructFilterJson = async (filterData) => {
    var query = [];
    if (filterData && filterData.length > 0) {
      var arr = [];
      filterData.map((filter) => {
        if (!filter.filters) {
          arr.push({
            field: filter.field,
            operators: filter.operator,
            strValue: filter.value,
            logic: filter.logic ? filter.logic : "or",
            tempVal: filter.value,
          });
        } else {
          filter.filters.map((innerFilter) => {
            if (typeof innerFilter.value === "object") {
              if (
                innerFilter.field.endsWith("_Post") ||
                innerFilter.field.endsWith("_Pre") ||
                innerFilter.field.endsWith("_Current")
              ) {
                let fieldName = innerFilter.field.split("_");
                arr.push({
                  field: fieldName[0],
                  type: fieldName[1],
                  operators: innerFilter.operator,
                  intvalue: innerFilter.value,
                  logic: filter.logic ? filter.logic : "or",
                  tempVal: innerFilter.value,
                });
              } else {
                 //date field  before or equal to validations
                 if (innerFilter.operator === "lte" || innerFilter.operator === "lt") {
                  arr.push(
                    {
                      field: innerFilter.field,
                      operators: innerFilter.operator,
                      dateValue: innerFilter.value,
                      logic: filter.logic ? filter.logic : "or",
                      tempVal: innerFilter.value,
                    },
                    // {
                    //   field: innerFilter.field,
                    //   operators: "isnull",
                    //   dateValue: null,
                    //   logic:"and",
                    //   tempVal: null,
                    // }
                  );
                } else {
                  arr.push({
                    field: innerFilter.field,
                    operators: innerFilter.operator,
                    dateValue: innerFilter.value,
                    logic: filter.logic ? filter.logic : "or",
                    tempVal: innerFilter.value,
                  });
                }
              }
            } else if (typeof innerFilter.value === "string") {
              arr.push({
                field: innerFilter.field,
                operators: innerFilter.operator,
                strValue:
                  innerFilter.value === "" ||
                  innerFilter.value === " [blank]" ||
                  innerFilter.value === "undefined"
                    ? null
                    : innerFilter.value,
                logic: filter.logic ? filter.logic : "or",
                tempVal:
                  innerFilter.value === "" ||
                  innerFilter.value === " [blank]" ||
                  innerFilter.value === "undefined"
                    ? null
                    : innerFilter.value,
              });
            } else if (typeof innerFilter.value === "number") {
              if (
                innerFilter.field.endsWith("_Post") ||
                innerFilter.field.endsWith("_Pre") ||
                innerFilter.field.endsWith("_Current")
              ) {
                let fieldName = innerFilter.field.split("_");
                arr.push({
                  field: fieldName[0],
                  type: fieldName[1],
                  operators: innerFilter.operator,
                  intvalue: innerFilter.value,
                  logic: filter.logic ? filter.logic : "or",
                  tempVal: innerFilter.value,
                });
              } else {
                arr.push({
                  field: innerFilter.field,
                  operators: innerFilter.operator,
                  intvalue: innerFilter.value,
                  logic: filter.logic ? filter.logic : "or",
                  tempVal: innerFilter.value,
                });
              }
            } else if (typeof innerFilter.value === "boolean") {
              arr.push({
                field: innerFilter.field,
                operators: innerFilter.operator,
                boolValue: innerFilter.value,
                logic: filter.logic ? filter.logic : "or",
                tempVal: innerFilter.value,
              });
            }
          });
        }
      });

      let pp = arr.filter(
        (ele, ind) =>
          ind ===
          arr.findIndex(
            (elem) => elem.field === ele.field &&
              elem.tempVal === ele.tempVal &&
              elem.type === ele.type &&
              ele.operators === elem.operators &&
              ele.logic === elem.logic
          )
      );

      query.push({
        logic: "or",
        filters: pp,
      });
    }
    return query;
  };

  buildRiskViewRequest = async (isParent) => {
    // Save selected ids during edit
    const riskViewId = isParent ? this.state.parentViewId : this.state.editFlag ? this.state.viewId : 0;
    if (this.state.editFlag) {
      this.saveSelectedIds(this.state.finalRiskList);
    }

    // Top-X validation
    if (
      this.state.parentSelectedTopBottom &&
      this.state.parentSelectedTopBottom != ""
    ) {
      if (
        this.state.parentSelectedNumber == 0 ||
        this.state.parentSelectedField == null ||
        this.state.parentSelectedField == ""
      ) {
        toastr.error("Invalid Top-X inputs");
        return;
      }
    } else if (
      this.state.parentSelectedField != null &&
      this.state.parentSelectedField != ""
    ) {
      if (
        this.state.parentSelectedNumber == 0 ||
        this.state.parentSelectedTopBottom == ""
      ) {
        toastr.error("Invalid Top-X inputs");
        return;
      }
    }
    var filterData = this.state.existingFilter
      ? this.state.existingFilter
      : [];
    var riskFilters = await this.constructFilterJson(filterData);
    await this.changeCheckBoxValues(riskFilters);
    return {
      riskfilter: this.state.selectedIds.length === 0 ? riskFilters : [],
      FilterQuery:
        this.state.selectedIds.length === 0
          ? JSON.stringify(filterData)
          : "{}",
      Type: "Risk",
      OrgUnitIds: this.state.OrgUnitIds,
      Name: this.state.Name.trim(),
      description: this.state.description,
      ImpactId:
        this.state.parent_date_impact == "Date"
          ? this.state.parent_datefield_value &&
          this.state.parent_datefield_value.impactId
          : this.state.parentSelectedField &&
          this.state.parentSelectedField.impactId,
      Field:
        this.state.parent_date_impact == "Impact"
          ? this.state.parentSelectedField.name
          : null,
      FieldType:
        this.state.parent_date_impact == "Impact"
          ? this.state.parentSelectedField.type
          : null,
      TopOrBottom:
        this.state.parent_date_impact == "Impact"
          ? this.state.parentSelectedTopBottom
          : null,
      TopOrBottomCount:
        this.state.parent_date_impact == "Impact"
          ? this.state.parentSelectedNumber
          : null,
      Scope: 0,
      ViewId: riskViewId,
      CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      RiskIds: this.state.selectedIds,
      IsWorkstreamchanged: this.state.IsWorkstreamchanged ? true : false,
      TopxType: this.state.parent_date_impact,

      // dynamicdatset
      TopxDateMode:
        this.state.parent_date_impact == "Date" ? this.state.parent_mode_value : null,
      TopxDateCount:
        this.state.parent_date_impact == "Date" ? this.state.parent_days_value : null,
      TopxDateField:
        this.state.parent_date_impact == "Date"
          ? this.state.parent_datefield_value.name
          : null,
      isSelectAllWorkstream: this.state.isSelectAllWorkstream,
      isParent: isParent
    };
  };

  buildTaskViewRequest = async(isParent) =>{
    const taskViewId = isParent ? this.state.parentViewId : this.state.editFlag ? this.state.viewId : 0;
    if (
      this.state.parentSelectedTopBottom &&
      this.state.parentSelectedTopBottom != ""
    ) {
      if (
        this.state.parentSelectedNumber == 0 ||
        this.state.parentSelectedField == null ||
        this.state.parentSelectedField == ""
      ) {
        toastr.error("Invalid Top-X inputs");
        return;
      }
    } else if (
      this.state.parentSelectedField != null &&
      this.state.parentSelectedField != ""
    ) {
      if (
        this.state.parentSelectedNumber == 0 ||
        this.state.parentSelectedTopBottom == ""
      ) {
        toastr.error("Invalid Top-X inputs");
        return;
      }
    }
    let taskFilterData = this.state.taskFilter ? this.state.taskFilter : [];

    let taskFilter = await this.constructFilterJson(taskFilterData);
    await this.changeCheckBoxValues(taskFilter);
    return {
      riskfilter: this.state.selectedTaskIds.length === 0 ? taskFilter : [],
      FilterQuery:
        this.state.selectedTaskIds.length === 0
          ? JSON.stringify(taskFilterData)
          : "{}",
      Type: "Task",
      OrgUnitIds: this.state.OrgUnitIds,
      Name: this.state.Name.trim(),
      description: this.state.description,
      Scope: 0,
      ViewId: taskViewId,
      CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      TaskIds: this.state.selectedTaskIds,
      IsWorkstreamchanged: this.state.IsWorkstreamchanged ? true : false,
      isSelectAllWorkstream: this.state.isSelectAllWorkstream,
      ImpactId:
        this.state.parent_date_impact == "Date"
          ? this.state.parent_datefield_value &&
          this.state.parent_datefield_value.impactId
          : this.state.parentSelectedField &&
          this.state.parentSelectedField.impactId,
      Field:
        this.state.parent_date_impact == "Impact"
          ? this.state.parentSelectedField.name
          : null,
      FieldType:
        this.state.parent_date_impact == "Impact"
          ? this.state.parentSelectedField.type
          : null,
      TopOrBottom:
        this.state.parent_date_impact == "Impact"
          ? this.state.parentSelectedTopBottom
          : null,
      TopOrBottomCount:
        this.state.parent_date_impact == "Impact"
          ? this.state.parentSelectedNumber
          : null,
      TopxType: this.state.parent_date_impact,

      TopxDateMode:
        this.state.parent_date_impact == "Date" ? this.state.parent_mode_value : null,
      TopxDateCount:
        this.state.parent_date_impact == "Date" ? this.state.parent_days_value : null,
      TopxDateField:
        this.state.parent_date_impact == "Date"
          ? this.state.parent_datefield_value.name
          : null,
      isParent: isParent
    };
  }

  saveQuery = async () => {
    try {
      console.log("this.state.viewFlag",this.state.viewFlag);
      //For Json serialize purpose
      Date.prototype.toJSON = function () {
        return moment(this).format("YYYY-MM-DDTHH:mm:ss");
      };
      var request = {};
      if (this.state.viewFlag === "RISK") {
        request = await this.buildRiskViewRequest(false);
      } else if (this.state.viewFlag === "ACTION" || this.state.viewFlag === "MITI") {
        var parentReq = await this.buildRiskViewRequest(true);
        if (
          this.state.actSelectedTopBottom &&
          this.state.actSelectedTopBottom != ""
        ) {
          if (
            this.state.actSelectedNumber == 0 ||
            this.state.actSelectedField == null ||
            this.state.actSelectedField == ""
          ) {
            toastr.error("Invalid Top-X inputs");
            return;
          }
        } else if (
          this.state.actSelectedField != null &&
          this.state.actSelectedField != ""
        ) {
          if (
            this.state.actSelectedNumber == 0 ||
            this.state.actSelectedTopBottom == ""
          ) {
            toastr.error("Invalid Top-X inputs");
            return;
          }
        }
        var mitigationFilterData = this.state.mitigationFilter
          ? this.state.mitigationFilter
          : [];

        var taskFilter = await this.constructFilterJson(
          mitigationFilterData
        );
        await this.changeCheckBoxValues(taskFilter);
        request = {
          riskfilter:
            this.state.selectedActionIds.length === 0 ? taskFilter : [],
          FilterQuery:
            this.state.selectedActionIds.length === 0
              ? JSON.stringify(mitigationFilterData)
              : "{}",
          Type: "Mitigation",
          OrgUnitIds: this.state.OrgUnitIds,
          Name: this.state.Name.trim(),
          description: this.state.description,
          ImpactId:
            this.state.date_impact == "Date"
              ? this.state.datefield_value &&
                this.state.datefield_value.impactId
              : this.state.actSelectedField &&
                this.state.actSelectedField.impactId,
          Field:
            this.state.date_impact == "Impact"
              ? this.state.actSelectedField.name
              : null,
          FieldType:
            this.state.date_impact == "Impact"
              ? this.state.actSelectedField.type
              : null,
          TopOrBottom:
            this.state.date_impact == "Impact"
              ? this.state.actSelectedTopBottom
              : null,
          TopOrBottomCount:
            this.state.date_impact == "Impact"
              ? this.state.actSelectedNumber
              : null,
          Scope: 0, // parseInt(this.state.scope),
          ViewId: this.state.editFlag ? this.state.viewId : 0,
          CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
          ActionIds: this.state.selectedActionIds,
          IsWorkstreamchanged: this.state.IsWorkstreamchanged ? true : false,
          TopxType: this.state.date_impact,
          // dynamicdatset
          TopxDateMode:
            this.state.date_impact == "Date" ? this.state.act_mode_value : null,
          TopxDateCount:
            this.state.date_impact == "Date" ? this.state.days_value : null,
          TopxDateField:
            this.state.date_impact == "Date"
              ? this.state.datefield_value.name
              : null,
          isSelectAllWorkstream:this.state.isSelectAllWorkstream,
          ParentDataset: parentReq,
          ParentViewId: this.state.parentViewId,
          IsParent: false
        };
      }else if(this.state.viewFlag === "TASK"){
        request = await this.buildTaskViewRequest(false);
      }else if(this.state.viewFlag === "SUBTASK"){
        var parentReq = await this.buildTaskViewRequest(true);
        if (
          this.state.actSelectedTopBottom &&
          this.state.actSelectedTopBottom != ""
        ) {
          if (
            this.state.actSelectedNumber == 0 ||
            this.state.actSelectedField == null ||
            this.state.actSelectedField == ""
          ) {
            toastr.error("Invalid Top-X inputs");
            return;
          }
        } else if (
          this.state.actSelectedField != null &&
          this.state.actSelectedField != ""
        ) {
          if (
            this.state.actSelectedNumber == 0 ||
            this.state.actSelectedTopBottom == ""
          ) {
            toastr.error("Invalid Top-X inputs");
            return;
          }
        }
        let subtaskFilterData = this.state.subTaskFilter ? this.state.subTaskFilter : [];
        let subtaskFilter = await this.constructFilterJson(subtaskFilterData);
        await this.changeCheckBoxValues(subtaskFilter);
        request = {
          riskfilter: this.state.selectedSubTaskIds.length === 0 ? subtaskFilter : [],
          FilterQuery:
            this.state.selectedSubTaskIds.length === 0
              ? JSON.stringify(subtaskFilterData)
              : "{}",
          Type: "TaskAction",
          OrgUnitIds: this.state.OrgUnitIds,
          Name: this.state.Name.trim(),
          description: this.state.description,
          Scope: 0,
          ViewId: this.state.editFlag ? this.state.viewId : 0,
          CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
          taskActionIds: this.state.selectedSubTaskIds,
          IsWorkstreamchanged: this.state.IsWorkstreamchanged ? true : false,
          isSelectAllWorkstream: this.state.isSelectAllWorkstream,
          ImpactId:
            this.state.date_impact == "Date"
              ? this.state.datefield_value &&
                this.state.datefield_value.impactId
              : this.state.actSelectedField &&
                this.state.actSelectedField.impactId,
          Field:
            this.state.date_impact == "Impact"
              ? this.state.actSelectedField.name
              : null,
          FieldType:
            this.state.date_impact == "Impact"
              ? this.state.actSelectedField.type
              : null,
          TopOrBottom:
            this.state.date_impact == "Impact"
              ? this.state.actSelectedTopBottom
              : null,
          TopOrBottomCount:
            this.state.date_impact == "Impact"
              ? this.state.actSelectedNumber
              : null,
              TopxType: this.state.date_impact,

          TopxDateMode:
            this.state.date_impact == "Date" ? this.state.mode_value : null,
          TopxDateCount:
            this.state.date_impact == "Date" ? this.state.days_value : null,
          TopxDateField:
            this.state.date_impact == "Date"
              ? this.state.datefield_value.name
              : null,
          ParentDataset: parentReq,
          ParentViewId: this.state.parentViewId,
          IsParent: false
        };
      }
      this.setState({ ...this.state, loader: true });
      let response = this.state.editFlag
        ? await Api.updateView(request)
        : await Api.saveView(request);
      //updateView
      if (response.status === 200) {
        toastr.success(response.message);
        this.handleClose();
        await this.getMitigationViewAxis();
        await this.getRiskDataSource();
        await this.getTaskDatasetList();
        await this.getTaskActionDatasetList();
        let DSObj = {};

        if (this.state.viewFlag === "MITI" || this.state.viewFlag === "ACTION") {
          DSObj = this.state.MitigationDatasourceListTemp.find(
            (item) => item.name == request.Name
          );
        } else if (this.state.viewFlag === "RISK") {
          DSObj = this.state.riskDatasetListTemp.find(
            (item) => item.name == request.Name
          );
        } else if (this.state.viewFlag === "TASK") {
          DSObj = this.state.taskDatasetList.find(
            (item) => item.name == request.Name
          );
        }else if (this.state.viewFlag === "SUBTASK") {
          DSObj = this.state.subTaskDatasetList.find(
            (item) => item.name == request.Name
          );
        }
        let flag = "ALL";
        if (this.state.viewFlag === "MITI" || this.state.viewFlag === "ACTION") {
          flag = "ACTION";
          // this.ToggleActionDataset();
        } else if(this.state.viewFlag === "RISK"){
          flag = "RISK";
          // this.ToggleRiskDataset();
        }else if(this.state.viewFlag === "TASK"){
          flag = "TASK";
          // this.ToggleTaskDataset();
        }else if(this.state.viewFlag === "SUBTASK"){
          flag = "SUBTASK";
          // this.ToggleSubTaskDataset();
        }
        await this.selectViewAction(DSObj, flag);
        this.setState({ ...this.state, loader: false });
      } else {
        toastr.error(response.message);
        this.setState({ ...this.state, loader: false });
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };

  isTopXInvalid = (viewType) => {
    const config = this.getTopXConfig(viewType);
    if (!config) return false; // safety

    const type = this.state[config.typeKey];
    if (!type) return true;

    // Impact
    if (type === "Impact") {
      return (
        !this.state[config.positionKey] ||
        !this.state[config.numberKey] ||
        !this.state[config.fieldKey]
      );
    }

    // Date
    if (type === "Date") {
      return (
        !this.state[config.modeKey] ||
        !this.state[config.daysKey] ||
        !this.state[config.dateFieldKey]
      );
    }

    return false;
  };

  getParentViewType = (viewType) => {
    const map = {
      ACTION: "RISK",
      ACTIVITY: "TASK"
    };
    return map[viewType];
  };

  getSubmitValidations = () => {
    if (!this.state.Name) return true;
    const { viewType } = this.state;

    if (this.isTopXInvalid(viewType)) return true;

    const parentType = this.getParentViewType(viewType);
    if (parentType && this.isTopXInvalid(parentType)) return true;

    return false;
  };

  getNumberForValue = (value) => {
    try {
      if (value == "Seven Days") {
        return 7;
      } else if (value == "Fourteen Days") {
        return 14;
      } else if (value == "Thirty Days") {
        return 30;
      } else if (value == "Ninety Days") {
        return 90;
      } else if (value == "One eighty Days") {
        return 180;
      } else if (value == "Three sixty Five Days") {
        return 365;
      }
    } catch (err) {
      return 0;
    }
  };

  selectionChange = (event) => {
    const data = this.state.riskList.map((item) => {
      if (item.riskRegisterId === event.dataItem.riskRegisterId) {
        item.selected = !event.dataItem.selected;
      }
      return item;
    });
    this.saveSelectedIds(data);
    this.setState({ data });
  };
  rowClick = (event) => {
    let last = this.lastSelectedIndex;
    const data = [...this.state.riskList];
    const current = data.findIndex((dataItem) => dataItem === event.dataItem);

    if (!event.nativeEvent.shiftKey) {
      this.lastSelectedIndex = last = current;
    }

    if (!event.nativeEvent.ctrlKey) {
      data.forEach((item) => (item.selected = false));
    }
    const select = !event.dataItem.selected;
    for (let i = Math.min(last, current); i <= Math.max(last, current); i++) {
      data[i].selected = select;
    }
    this.saveSelectedIds(data);
    this.setState({ data });
  };

  saveSelectedIds = (data) => {
    let listOfIds = [];
    for (let row of Object.values(data)) {
      if (row.selected) {
        listOfIds.push(row.riskRegisterId);
      }
    }
    this.setState({ selectedIds: listOfIds, filteredRiskIds: listOfIds });
  };

  saveActionSelectedIds = (data) => {
    let listOfIds = [];
    for (let row of Object.values(data)) {
      if (row.selected) {
        listOfIds.push(row.riskRegisterActionId);
      }
    }
    this.setState({ selectedActionIds: listOfIds });
  };
  headerSelectionChange = (event) => {
    const checked = event.syntheticEvent.target.checked;
    const data = this.state.riskList.map((item) => {
      item.selected = checked;
      return item;
    });
    this.saveSelectedIds(data);
    this.setState({ data });
  };
  expandChange(event) {
    event.dataItem.expanded = event.value;
    let riskRegisterId = event.dataItem.riskRegisterId;
    this.setState({ ...this.state });
    if (!event.value || event.dataItem.mitigationResps) {
      return;
    }
    let data = this.state.riskList.slice();
    let index = data.findIndex((d) => d.riskRegisterId === riskRegisterId);
    data[index].mitigationResps = this.state.riskList.filter(
      (d) => d.riskRegisterId === riskRegisterId
    );
    this.setState({ riskList: data });
  }

  getOrganizationsUnits = async () => {
    try {
      this.setState({ ...this.state, loader: true });

      var loggedClient = secureLocalStorage.getItem("loggedClient");
      var createdby =
        loggedClient === "user"
          ? secureLocalStorage.getItem("userId")
          : secureLocalStorage.getItem("tenantId");
      var request = {
        CreatedBy: parseInt(createdby),
      };
      let response = await Api.getOrgUnits(request);
      if (response.status === 200) {
        this.setState({
          ...this.state,
          data: response.organisationUnit,
          loader: false,
        });
      } else {
        this.setState({ ...this.state, data: [], loader: false });
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };

  getMitigationByDataByOrgIdsNew = async (idList) => {
    try {
      if (idList) {
        var request = {
          OrgUnitIds: idList,
        };
        let response = await Api.getMitigationByDataByOrgIds(request);
        if (response.status === 200) {
          return response;
        } else {
          return [];
        }
      }
    } catch (err) {
      return [];
    }
  };

  getRiskListByOrgUnitIdsNew = async (idList) => {
    try {
      if (idList) {
        var request = {
          OrgUnitIds: idList,
        };
        let response = await Api.getRiskForOrgUnit(request);
        if (response.status === 200) {
          return response;
        } else {
          return [];
        }
      }
    } catch (err) {
      return [];
    }
  };

  getRiskListByOrgUnitIds = async (idList) => {
    try {
      var request = {
        OrgUnitIds: idList,
      };

      this.state = { ...this.state, loader: true };
      let response = await Api.getRiskForOrgUnit(request);
      if (response.status === 200) {
        let impactMaster = [];
        response.riskRegister.map((riskReg) => {
          if (!riskReg.organizationUnitName) {
            riskReg.organizationUnitName = null;
          }
          if (!riskReg.number) {
            riskReg.number = null;
          }
          if (!riskReg.riskTitle) {
            riskReg.riskTitle = null;
          }
          if (!riskReg.isOpportunity) {
            riskReg.isOpportunity = null;
          }
          if (!riskReg.name) {
            riskReg.name = null;
          }
          if (!riskReg.cause) {
            riskReg.cause = null;
          }
          if (!riskReg.existingControl) {
            riskReg.existingControl = null;
          }
          if (!riskReg.impactComments) {
            riskReg.impactComments = null;
          }

          if (!riskReg.owner) {
            riskReg.owner = null;
          }

          if (!riskReg.updatedBy) {
            riskReg.updatedBy = null;
          }
          if (riskReg.proximityDate) {
            riskReg.proximityDate = new Date(riskReg.proximityDate);
          } else {
            riskReg.proximityDate = null;
          }
          if (riskReg.closedDate) {
            riskReg.closedDate = new Date(riskReg.closedDate);
          } else {
            riskReg.closedDate = null;
          }
          if (riskReg.updatedDate) {
            var time = moment(riskReg.updatedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let updatedDate = time;
            riskReg.updatedDate = riskReg.updatedDate
              ? new Date(updatedDate)
              : "";
          } else {
            riskReg.updatedDate = null;
          }
          if (riskReg.createdDate) {
            var time = moment(riskReg.createdDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let createdDate = time;
            riskReg.createdDate = riskReg.createdDate
              ? new Date(createdDate)
              : "";
          } else {
            riskReg.createdDate = null;
          }

          if (riskReg.riskTypeNames && riskReg.riskTypeNames.length > 0) {
            let hashArr = this.stringToHash(
              riskReg.riskTypeNames.toString(),
              "riskTypeNames"
            );

            riskReg["riskTypeNames"] = hashArr;
          } else {
            riskReg["riskTypeNames"] = "undefined";
          }
          if (riskReg.isClosed) {
            riskReg.isClosed = "Open";
          } else {
            riskReg.isClosed = "Closed";
          }
          if (riskReg && riskReg.impactResponse) {
            impactMaster = riskReg.impactResponse;
          }
        });

        this.setState({ ...this.state, impactMaster: impactMaster });
        await this.createDynamicDropdowns(response.riskRegister);
        await this.createDynamicCols(response.riskRegister);
        var riskData = response.riskRegister.map((dataItem) =>
          Object.assign({ selected: false }, dataItem)
        );
        this.setState({
          ...this.state,
          selectedOrgUnit: [],
          riskList: riskData,
          riskTemp: riskData,
          loader: false,
          filter: {
            logic: "and",
            filters: [],
          },
        });
        //  selectedOrgUnit
      } else {
        this.setState({
          ...this.state,
          selectedOrgUnit: [],
          riskList: [],
          finalRiskList:[],
          riskTemp: [],
          loader: false,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  stringToHashForCF(stringArr, data) {
    let hashArr = [];
    if (stringArr && stringArr.includes(",")) {
      let valArr = stringArr.split(",");
      valArr &&
        valArr.map((item1) => {
          let cfVal = data.find((item) => item.name === item1);
          if (cfVal) {
            hashArr.push(cfVal.hashValue);
          }
        });
    } else {
      let cfVal = data.find((item) => item.name === stringArr);
      if (cfVal) {
        hashArr.push(cfVal.hashValue);
      }
    }
    return hashArr.toString();
  }

  stringToHash(stringArr, cols) {
    let hashArr = [];

    if (stringArr && stringArr.includes(",")) {
      let valArr = stringArr.split(",");
      if (cols === "riskTypeNames") {
        valArr &&
          valArr.map((item1) => {
            let risktype = this.state.riskTypemaster.find(
              (item) => item.name === item1
            );
            if (risktype) {
              hashArr.push(risktype.hashValue);
            }
          });
      }
    } else {
      if (stringArr !== "") {
        if (cols === "riskTypeNames") {
          let risktype = this.state.riskTypemaster.find(
            (item) => item.name === stringArr
          );
          if (risktype) {
            hashArr.push(risktype.hashValue);
          }
        }
      }
    }

    return hashArr.toString();
  }

  getMitigationByDataByOrgIds = async (idList) => {
    try {
      var request = {
        OrgUnitIds: idList,
      };
      this.state = { ...this.state, mitigationData: [] };
      let response = await Api.getMitigationByDataByOrgIds(request);
      if (response.status === 200) {
        response.riskMitigationResponse.map((riskReg) => {
          if (!riskReg.organisationName) {
            riskReg.organisationName = null;
          }
          if (!riskReg.riskNumber) {
            riskReg.riskNumber = null;
          }
          if (!riskReg.riskName) {
            riskReg.riskName = null;
          }
          if (!riskReg.isOpportunity) {
            riskReg.isOpportunity = null;
          }
          if (!riskReg.name) {
            riskReg.name = null;
          }
          if (!riskReg.number) {
            riskReg.number = null;
          }
          if (!riskReg.control) {
            riskReg.control = null;
          }
          if (!riskReg.externalReference) {
            riskReg.externalReference = null;
          }
          if (!riskReg.actionType) {
            riskReg.actionType = null;
          }
          if (!riskReg.owner) {
            riskReg.owner = null;
          }
          if (!riskReg.updatedBy) {
            riskReg.updatedBy = null;
          }
         
          if (riskReg.actualCompletionDate) {
            riskReg.actualCompletionDate = new Date(
              riskReg.actualCompletionDate
            );
          } else {
            riskReg.actualCompletionDate = null;
          }
          if (riskReg.originalCompletionDate) {
            riskReg.originalCompletionDate = new Date(
              riskReg.originalCompletionDate
            );
          } else {
            riskReg.originalCompletionDate = null;
          }
          if (riskReg.projectedCompletionDate) {
            riskReg.projectedCompletionDate = new Date(
              riskReg.projectedCompletionDate
            );
          } else {
            riskReg.projectedCompletionDate = null;
          }
          if (riskReg.proximityDate) {
            riskReg.proximityDate = new Date(riskReg.proximityDate);
          } else {
            riskReg.proximityDate = null;
          }

          if (riskReg.updatedDate) {
            var time = moment(riskReg.updatedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let updatedDate = time;
            riskReg.updatedDate = riskReg.updatedDate
              ? new Date(updatedDate)
              : "";
          } else {
            riskReg.updatedDate = null;
          }
          if (riskReg.createdDate) {
            var time = moment(riskReg.createdDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let createdDate = time;
            riskReg.createdDate = riskReg.createdDate
              ? new Date(createdDate)
              : "";
          } else {
            riskReg.createdDate = null;
          }

          if (riskReg.riskTypeNames && riskReg.riskTypeNames.length > 0) {
            let hashArr = this.stringToHash(
              riskReg.riskTypeNames.toString(),
              "riskTypeNames"
            );
            riskReg["riskTypeNames"] = hashArr;
          } else {
            riskReg["riskTypeNames"] = "undefined";
          }
          riskReg["spi"] = parseInt(riskReg.spi);
          riskReg["percentageCompletion"] = parseInt(
            riskReg.percentageCompletion
          );
          if (riskReg.isOpen) {
            riskReg.isOpen = "Open";
          } else {
            riskReg.isOpen = "Close";
          }
          if (riskReg.approved) {
            riskReg.approved = "Yes";
          } else {
            riskReg.approved = "No";
          }
        });

        this.setState({
          ...this.state,
          // loader: false,
          mitigationData: response.riskMitigationResponse,
          mitigationDataTemp: response.riskMitigationResponse,
        });
      } else {
        this.setState({
          ...this.state,
          // loader: false,
          mitigationData: [],
          mitigationDataTemp: [],
        });
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };

  getTasksById =async(idList)=>{
    try{
      var request = {
        workstreamIds: idList,
        ScreenFrom:"Dataset"
      };
      this.setState({ ...this.state, taskDataList: [] });
      let response = await Api.getTasksById(request);

      if (response.status === 200) {
        response.taskRegisters.map((riskReg) => {
        
          if (riskReg.originalCompletionDate) {
            riskReg.originalCompletionDate =new Date(riskReg.originalCompletionDate); //riskReg.originalCompletionDate? moment(new Date(riskReg.originalCompletionDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.projectedCompletionDate) {
            riskReg.projectedCompletionDate =new Date(riskReg.projectedCompletionDate);//riskReg.projectedCompletionDate? moment(new Date(riskReg.projectedCompletionDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.actualCompletionDate) {
            riskReg.actualCompletionDate =new Date(riskReg.actualCompletionDate);//riskReg.actualCompletionDate? moment(new Date(riskReg.actualCompletionDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.proximityAlertDate) {
            riskReg.proximityAlertDate = new Date(riskReg.proximityAlertDate);//riskReg.proximityAlertDate? moment(new Date(riskReg.proximityAlertDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.updatedDate) {
            var time = moment(riskReg.updatedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let updatedDate = time;
            riskReg.updatedDate = riskReg.updatedDate
              ? new Date(updatedDate)
              : "";
          }
          if (riskReg.createdDate) {
            let time = moment(riskReg.createdDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let createdDate = time;
            riskReg.createdDate = riskReg.createdDate
              ? new Date(createdDate)
              : "";
          }
          if (riskReg.closedDate) {
            let time = moment(riskReg.closedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let closedDate = time;
            riskReg.closedDate = riskReg.closedDate
              ? new Date(closedDate)
              : "";
          }
          
          if (riskReg.isClosed===false) {
            riskReg.isClosed = "Open";
          } else {
            riskReg.isClosed = "Closed";
          }
          if (riskReg.isApproved===false) {
            riskReg.isApproved = "No";
          } else {
            riskReg.isApproved = "Yes";
          }
        });
        await this.createDynamicDropdowns(response.taskRegisters);
        this.setState({ ...this.state, taskDataList: response.taskRegisters  });
        await this.refs.childTask.initTask(response.taskRegisters);
      }
    }catch(err){
      console.error(err);
    }
  }
  getTaskActionsByWorkstreamId =async(idList)=>{
    try{
      var request = {
        workstreamIds: idList,
      };
      this.setState({ ...this.state, subTaskDataList: [] });
      let response = await Api.getTaskActionsByWorkstreamId(request);

      if (response.status === 200) {
        response.taskActions.map((riskReg) => {
        
          if (riskReg.originalCompletionDate) {
            riskReg.originalCompletionDate =new Date(riskReg.originalCompletionDate); //riskReg.originalCompletionDate? moment(new Date(riskReg.originalCompletionDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.projectedCompletionDate) {
            riskReg.projectedCompletionDate =new Date(riskReg.projectedCompletionDate);//riskReg.projectedCompletionDate? moment(new Date(riskReg.projectedCompletionDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.actualCompletionDate) {
            riskReg.actualCompletionDate =new Date(riskReg.actualCompletionDate);//riskReg.actualCompletionDate? moment(new Date(riskReg.actualCompletionDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.proximityAlertDate) {
            riskReg.proximityAlertDate = new Date(riskReg.proximityAlertDate);//riskReg.proximityAlertDate? moment(new Date(riskReg.proximityAlertDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.updatedDate) {
            var time = moment(riskReg.updatedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let updatedDate = time;
            riskReg.updatedDate = riskReg.updatedDate
              ? new Date(updatedDate)
              : "";
          }
          if (riskReg.createdDate) {
            let time = moment(riskReg.createdDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let createdDate = time;
            riskReg.createdDate = riskReg.createdDate
              ? new Date(createdDate)
              : "";
          }
          if (riskReg.closedDate) {
            let time = moment(riskReg.closedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let closedDate = time;
            riskReg.closedDate = riskReg.closedDate
              ? new Date(closedDate)
              : "";
          }
          
          
          if (riskReg.isClosed===false) {
            riskReg.isClosed = "Open";
          } else {
            riskReg.isClosed = "Closed";
          }
          if (riskReg.isApproved===false) {
            riskReg.isApproved = "No";
          } else {
            riskReg.isApproved = "Yes";
          }
        });
        this.setState({ ...this.state, subTaskDataList: response.taskActions });
        await this.refs.childSubTask.initSubTasks(response.taskActions);
      }
    }catch(err){
      console.error(err);
    }
  }
  getMatrixColorCodes = async () => {
    try {
      // var req = {
      //   WorkstreamId: 0,
      // };
      let response = await Api.MatrixColor();
      if (response.status === 200) {
       // normal,opportunity
       let normal_opp = response.matrixColor.find(
        (item) => item.riskType === "opportunity"
      );
      let opp_colorJsonData = JSON.parse(normal_opp.colorJsonData);

      //  normal,threat
      let normal_threat = response.matrixColor.find(
        (item) => item.riskType === "threat"
      );
      let threat_colorJsonData = JSON.parse(normal_threat.colorJsonData);
      this.setState({
        
        HeatMapConfigDataThreat: threat_colorJsonData,
        HeatMapConfigDataOpportunity: opp_colorJsonData,

        heatMapCount: response.heatmapCount,
        dynamicHeatmapProbabilityRange:
          response.dynamicHeatmapProbabilityRange,
      });
      }
    } catch (error) {
      console.error(error);
    }
  };

  //get all Grid data by workstream
  getAllDataByWorkstream = async (orgUnitListIds) => {
    if (orgUnitListIds && orgUnitListIds.length > 0) {
      if (this.refs.childAction) {
        this.refs.childAction.updateFilter();
      }
      let arr=[];
      let primeHideFlag =
        secureLocalStorage.getItem("isPrime") == true ? true : false;
      mapTree(this.state.data, "children", (item) => {
        if (orgUnitListIds.includes(item.unitId)) {
          if (!item.isPrime) {
            primeHideFlag = item.isPrime;
          }
        }
        arr.push(item.unitId);
        return item;
      });
      let isSelectAllWorkstream=arr.length===orgUnitListIds.length?true:false;
      this.getRiskListByOrgUnitIds(orgUnitListIds);
      this.getMitigationByDataByOrgIds(orgUnitListIds);
      this.getTasksById(orgUnitListIds);
      this.getTaskActionsByWorkstreamId(orgUnitListIds);
      this.getRiskTypeList();
      this.getCustomField();
      this.setState({
        ...this.state,
        isSelectAllWorkstream:isSelectAllWorkstream,
        dataState: {},
        OrgUnitIds: orgUnitListIds,
        IsWorkstreamchanged: true,
        selectedIds: [],
        filter: {
          logic: "and",
          filters: [],
        },
        existingFilter: [],
        sort: [],
        take: 10,//Math.round((window.innerHeight - 250) / 35),
        skip: 0,
        primeHideFlag: primeHideFlag,
      });
    }
  };

  setEmptyRiskList = async (ids) => {
    this.setState({
      ...this.state,
      riskList: [],
      finalRiskList:[],
      riskTemp: [],
      mitigationData: [],
      OrgUnitIds: [],
      taskDataList:[],
      subTaskDataList:[],
    });
    
    if(this.refs.childTask){
       this.refs.childTask.initTask([]);
    }
    if(this.refs.childSubTask){
       this.refs.childSubTask.initSubTasks([]);
    }
    
  };
 
  manageCustomValues() {}

  getCustomFieldMasterData = (fieldName, filter) => {
    try {
      let arr = this.state.customFieldsmaster.filter(
        (item) => item.fieldName === fieldName
      );
      if (arr && arr.length > 0) {
        let temp = [];
        arr[0].cfPossibleValues.map((item, index) => {
          let checked = this.checkCFinFilterValuesOrNot(
            fieldName,
            item.hashValue,
            filter
          );
          temp.push({
            id: index,
            name: item.possibleValues,
            checked: checked,
            hashValue: item.hashValue, //this.convertStrToHash(item),
          });
        });
        return temp;
      } else {
        return [];
      }
    } catch (err) {
      return [];
    }
  };
  //Custom field
  createDynamicDropdowns = async (products, filter) => {
    try {
      let dropdownColumn = [];
      products.map((res, i) => {
        res.customFields.map((item, j) => {
          if (dropdownColumn.length > 0) {
            if (!dropdownColumn.find((cf) => cf.fieldName === item.fieldName)) {
              dropdownColumn.push({
                fieldName: item.fieldName,
                data: this.getCustomFieldMasterData(item.fieldName, filter),
                inputType: this.getInputType(item.fieldName),
              });
            }
          } else {
            dropdownColumn.push({
              fieldName: item.fieldName,
              data: this.getCustomFieldMasterData(item.fieldName, filter),
              inputType: this.getInputType(item.fieldName),
            });
          }
        });
      });

      if (dropdownColumn.length > 0) {
        products.map((res) => {
          dropdownColumn.map((col) => {
            let temp = res.customFields.find(
              (item) => item.fieldName === col.fieldName
            );
            if (temp) {
              if (temp.inputType === "Multi Drop Down") {
                let val = temp.selectedCustomFieldNames
                  ? temp.selectedCustomFieldNames.toString()
                  : "";
                let hashArr = this.stringToHashForCF(val, col.data);
                res[col.fieldName] = hashArr;
              } else if (temp.inputType === "Single Drop Down") {
                let val =
                  temp.selectedCustomFieldNames &&
                  temp.selectedCustomFieldNames.length > 0
                    ? temp.selectedCustomFieldNames.toString()
                    : null;
                res[col.fieldName] = val;
              } else if (temp.inputType === "Free Text") {
                let val =
                  temp.multiText && temp.multiText != ""
                    ? temp.multiText
                    : null;
                res[col.fieldName] = val;
              } else if (temp.inputType === "Numeric") {
                let val =
                  temp.multiText && temp.multiText != ""
                    ? parseInt(temp.multiText)
                    : null;
                res[col.fieldName] = val;
              } else if (temp.inputType === "Date") {
                let val =
                  temp.multiText && temp.multiText != ""
                    ? new Date(temp.multiText)
                    : null;
                res[col.fieldName] = val;
              }
            } else {
              res[col.fieldName] = "";
            }
          });
        });
      }
      let columnsToShow = [];
      if (dropdownColumn.length > 0) {
        columnsToShow = dropdownColumn.map((item) => (
          <Column
            field={item.fieldName}
            title={item.fieldName}
            width="150px"
            cell={(props) =>
              this.viewMultiselectColsCustomDropdown(props, item)
            }
            columnMenu={(props) => this.getCustomFieldColumnMenu(props, item)}
            filter={this.getCustomFieldFilter(item)}
            headerClassName={this.checkItsinFilterOrNot(item.fieldName, filter)}
          />
        ));
      }
      this.setState({ ...this.state, dropdownColumns: columnsToShow });
    } catch (err) {
      console.log(err);
    }
  };

  getCustomFieldFilter = (item) => {
    if (item.inputType === "Multi Drop Down") {
      return "";
    } else if (item.inputType === "Single Drop Down") {
      return "text";
    } else if (item.inputType === "Free Text") {
      return "";
    } else if (item.inputType === "Numeric") {
      return "numeric";
    } else if (item.inputType === "Date") {
      return "date";
    } else {
      return "";
    }
  };
  getsortedrisklist=()=>{
    let sorted_arr =  this.state.riskTypemaster.sort(function (a, b) {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });
  }
  getcustomfieldlist=(list)=>{
    var sorted_arr =  list.sort(function (a, b) {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });
    return sorted_arr
  }
  
  getCustomFieldColumnMenu = (props, item) => {
    if (item.inputType === "Multi Drop Down") {
      this.getcustomfieldlist(item.data);
      return (
        <CustomFieldSearchMenu
          {...props}
          customFieldsmaster={item.data}
          existingFilter={this.state.existingFilter}
          filterChangeV={this.filterChangeV}
          clearFilter={this.clearFilter}
        />
      );
    }else if(item.inputType === "Single Drop Down"){
      return (                      
        <ColumnMenuCheckboxFilter
          {...props}
          data={this.state.riskList}
          getSelectedColumn={this.getSelectedColumn}
        />
      )
    } else {
      return (
        <ColumnMenuFilter
          {...props}
          getSelectedColumn={this.getSelectedColumn}
        />
      );
    }
  };

  getInputType = (fieldName) => {
    try {
      let arr = this.state.customFieldsmaster.find(
        (item) => item.fieldName == fieldName
      );
      if (arr) {
        return arr.inputType;
      } else {
        return undefined;
      }
    } catch (err) {
      console.log(err);
    }
  };

  //Impacts
  createDynamicCols = async (products, filter) => {
    try {
      let impactColumn = [];
      products.map((res, i) => {
        if (res.impactResponse) {
          res.impactResponse.map((item, j) => {
            if (impactColumn.length > 0) {
              if (!impactColumn.find((cf) => cf.fieldName == item.fieldName)) {
                impactColumn.push({
                  fieldName: item.name + "_" + item.type,
                  impactType: item.impactType,
                });
              }
            } else {
              impactColumn.push({
                fieldName: item.name + "_" + item.type,
                impactType: item.impactType,
              });
            }
          });
        }
      });
      // impactColumn.sort();
      // impactColumn.reverse();
      impactColumn = impactColumn.filter(
        (ele, ind) =>
          ind ===
          impactColumn.findIndex(
            (elem) =>
              elem.fieldName === ele.fieldName &&
              elem.impactType === ele.impactType
          )
      );

      if (impactColumn.length > 0) {
        products.map((res) => {
          impactColumn.map((col) => {
           if (col.impactType == "Qualitative") {
            let temp = res.impactResponse && res.impactResponse.find(
              (item) => item.name + "_" + item.type === col.fieldName
            );
            if (temp&&temp.type == "Post") {
              res[col.fieldName] =  temp.postQvalue;
            }else if (temp&&temp.type == "Pre"){
              res[col.fieldName] =temp.qValue;
            }else if (temp&&temp.type == "Current"){
              res[col.fieldName] =temp.currentQvalue;
            } else {
              res[col.fieldName] = 0;
            }
          } else {
            let temp = res.impactResponse && res.impactResponse.find(
              (item) => item.name + "_" + item.type === col.fieldName
            );
            if (temp&&temp.type == "Post") {
              res[col.fieldName] =  temp.postImpactValue;
            }else if (temp&&temp.type == "Pre"){
              res[col.fieldName] = temp.value;
            }else if (temp&&temp.type == "Current"){
              res[col.fieldName] = temp.currentImpactValue;
            } else {
              res[col.fieldName] = 0;
            }
          }
          });
        });
      }

      let columnsToShow = [];
      if (impactColumn.length > 0) {
        columnsToShow = impactColumn.map((item) => (
          <Column
            field={item.fieldName}
            title={this.getImpactUnit(item)}
            width="100px"
            editable={false}
            cell={(props) => this.getImpactCellComponent(props, item)}
            filter={"numeric"}
            columnMenu={(props) => (
              <ColumnMenuFilter
                {...props}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            headerClassName={this.checkItsinFilterOrNot(item.fieldName, filter)}
          />
        ));
      }
      this.setState({ ...this.state, impactColumns: columnsToShow });
    } catch (err) {
      console.log(err);
    }
  };

  getImpactCellComponent = (props, impact) => {
    if (impact.impactType == "Qualitative") {
      return (
        <QualitativeImpactEditComponent
          {...props}
          onEditCell={this.onEditCell}
        />
      );
    } else {
      return <ImpactEditComponent {...props} onEditCell={this.onEditCell} />;
    }
  };

  getImpactUnit = (impact) => {
    if (impact.impactType == "Qualitative") {
      var impactTemp = this.state.impactMaster.find(
        (item) => item.name + "_" + item.type == impact.fieldName
      );
      var res = impact.fieldName;
      if (impactTemp && impactTemp.name) {
        res = impactTemp.name + " / " + " (" + impactTemp.type + ")";
      }
      return res;
    } else {
      var impactTemp = this.state.impactMaster.find(
        (item) => item.name + "_" + item.type == impact.fieldName
      );
      var res = impact.fieldName;
      if (impactTemp && impactTemp.name) {
        res =
          impactTemp.name +
          " / " +
          impactTemp.units +
          " (" +
          impactTemp.type +
          ")";
      }
      return res;
    }
  };

  handleViewName = (e) => {
    this.setState({
      ...this.state,
      Name: e.target.value,
    });
  };

  mitigationFilterQuery = (query) => {
    this.setState({
      ...this.state,
      mitigationFilter: query,
    });
  };
  taskFilterQueryGenerator=(query)=>{
    this.setState({
      ...this.state,
      taskFilter: query,
    });
  }
  subTaskFilterQueryGenerator=(query)=>{
    this.setState({
      ...this.state,
      subTaskFilter: query,
    });
  }
  onEditCell = () => {};

  getYaxisValue = (obj) => {
    var temp = [];
    var yaxis = [];
    try {
      if (this.state.viewFlag == "MITI") {
        if (
          this.state.XAxisValue &&
          Object.keys(this.state.XAxisValue).length != 0
        ) {
          if (this.state.widgetName == "PIE_CHART") {
            if (obj.colsName && obj.colsName == "RiskNumber") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "ReductionFrequency" &&
                  item.colsName != "PercentageCompletion" &&
                  item.colsName != "Spi" && item.colsName != "ActionFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "RiskTitle") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "ReductionFrequency" &&
                  item.colsName != "PercentageCompletion" &&
                  item.colsName != "Spi" && item.colsName != "ActionFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "MitigationName") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "ReductionFrequency" &&
                  item.colsName != "PercentageCompletion" &&
                  item.colsName != "Spi" &&
                  item.colsName != "TotalActionCount" &&
                  item.colsName != "OpenActionsCount" &&
                  item.colsName != "ClosedActionsCount" &&
                  item.colsName != "ApprovedOpenActionsCount" &&
                  item.colsName != "UnapprovedOpenActionsCount" &&
                  item.colsName != "ActionFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "MitigationNumber") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "ReductionFrequency" &&
                  item.colsName != "PercentageCompletion" &&
                  item.colsName != "Spi" &&
                  item.colsName != "TotalActionCount" &&
                  item.colsName != "OpenActionsCount" &&
                  item.colsName != "ClosedActionsCount" &&
                  item.colsName != "ApprovedOpenActionsCount" &&
                  item.colsName != "UnapprovedOpenActionsCount" &&
                  item.colsName != "ActionFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "Owner") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "ReductionFrequency" &&
                  item.colsName != "PercentageCompletion" &&
                  item.colsName != "Spi" && item.colsName != "ActionFieldsCompletion"
              );
            } else {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "ReductionFrequency" &&
                  item.colsName != "PercentageCompletion" &&
                  item.colsName != "Spi" && item.colsName != "ActionFieldsCompletion"
              );
            }
          }else if (this.state.widgetName == "BAR_CHART") {
            if (obj.colsName && obj.colsName == "RiskNumber") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "ReductionFrequency" &&
                  item.colsName != "PercentageCompletion" &&
                  item.colsName != "Spi" && item.colsName != "ActionFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "RiskTitle") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "ReductionFrequency" &&
                  item.colsName != "PercentageCompletion" &&
                  item.colsName != "Spi" && item.colsName != "ActionFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "MitigationName") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "TotalActionCount" &&
                  item.colsName != "OpenActionsCount" &&
                  item.colsName != "ClosedActionsCount" &&
                  item.colsName != "ApprovedOpenActionsCount" &&
                  item.colsName != "UnapprovedOpenActionsCount" 
              );
            } else if (obj.colsName && obj.colsName == "MitigationNumber") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "TotalActionCount" &&
                  item.colsName != "OpenActionsCount" &&
                  item.colsName != "ClosedActionsCount" &&
                  item.colsName != "ApprovedOpenActionsCount" &&
                  item.colsName != "UnapprovedOpenActionsCount" 
              );
            } else if (obj.colsName && obj.colsName == "Owner") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "ReductionFrequency" &&
                  item.colsName != "PercentageCompletion" &&
                  item.colsName != "Spi" 
              );
            } else {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "ReductionFrequency" &&
                  item.colsName != "PercentageCompletion" &&
                  item.colsName != "Spi" && item.colsName != "ActionFieldsCompletion"
              );
            }
        }else {
            if (obj.colsName && obj.colsName == "RiskNumber") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "ReductionFrequency" &&
                  item.colsName != "PercentageCompletion" &&
                  item.colsName != "Spi" && item.colsName != "ActionFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "RiskTitle") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "ReductionFrequency" &&
                  item.colsName != "PercentageCompletion" &&
                  item.colsName != "Spi" && item.colsName != "ActionFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "MitigationName") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "TotalActionCount" &&
                  item.colsName != "OpenActionsCount" &&
                  item.colsName != "ClosedActionsCount" &&
                  item.colsName != "ApprovedOpenActionsCount" &&
                  item.colsName != "UnapprovedOpenActionsCount" && item.colsName != "ActionFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "MitigationNumber") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "TotalActionCount" &&
                  item.colsName != "OpenActionsCount" &&
                  item.colsName != "ClosedActionsCount" &&
                  item.colsName != "ApprovedOpenActionsCount" &&
                  item.colsName != "UnapprovedOpenActionsCount" && item.colsName != "ActionFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "Owner") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "ReductionFrequency" &&
                  item.colsName != "PercentageCompletion" &&
                  item.colsName != "Spi" && item.colsName != "ActionFieldsCompletion"
              );
            } else {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "ReductionFrequency" &&
                  item.colsName != "PercentageCompletion" &&
                  item.colsName != "Spi" && item.colsName != "ActionFieldsCompletion"
              );
            }
          }
        }
      } else if (this.state.viewFlag == "RISK") {
        if (
          this.state.XAxisValue &&
          Object.keys(this.state.XAxisValue).length != 0
        ) {
          if (this.state.widgetName == "PIE_CHART") {
            
            if (obj.colsName && obj.colsName == "RiskNumber") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "Frequency" &&
                  item.colsName != "TotalRiskCount" &&
                  item.colsName != "OpenRiskCount" &&
                  item.colsName != "ClosedRiskCount" &&
                  item.colsName != "PreRiskScore" &&
                  item.colsName != "PreWeightedRiskScore" && item.colsName != "RiskFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "RiskTitle") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "Frequency" &&
                  item.colsName != "TotalRiskCount" &&
                  item.colsName != "OpenRiskCount" &&
                  item.colsName != "ClosedRiskCount" &&
                  item.colsName != "PreRiskScore" &&
                  item.colsName != "PreWeightedRiskScore"&& item.colsName != "RiskFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "RiskTypeName") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "Frequency" &&
                  item.colsName != "PreRiskScore" &&
                  item.colsName != "PreWeightedRiskScore"&& item.colsName != "RiskFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "UnitName") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "Frequency" &&
                  item.colsName != "PreRiskScore" &&
                  item.colsName != "PreWeightedRiskScore"&& item.colsName != "RiskFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "Owner") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "Frequency" &&
                  item.colsName != "PreRiskScore" &&
                  item.colsName != "PreWeightedRiskScore"&& item.colsName != "RiskFieldsCompletion"
              );
            } else {
              yaxis = this.state.impactWithCountCols;
            }
          }if (this.state.widgetName == "BAR_CHART") {
            if (obj.colsName && obj.colsName == "RiskNumber") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "TotalRiskCount" &&
                  item.colsName != "OpenRiskCount" &&
                  item.colsName != "ClosedRiskCount"
              );
            } else if (obj.colsName && obj.colsName == "RiskTitle") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "TotalRiskCount" &&
                  item.colsName != "OpenRiskCount" &&
                  item.colsName != "ClosedRiskCount"
              );
            } else if (obj.colsName && obj.colsName == "RiskTypeName") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) => item.colsName != "Frequency"
              );
            } else if (obj.colsName && obj.colsName == "UnitName") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) => item.colsName != "Frequency"
              );
            } else if (obj.colsName && obj.colsName == "Owner") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) => item.colsName != "Frequency"
              );
            } else {
              if (this.state.widgetName == "HEAT_MAP") {
                yaxis = this.state.heatmapCols;
              } else {
                yaxis = this.state.impactWithCountCols;
              }
            }
          }
           else if (this.state.widgetName == "LINE_CHART") {
            if (obj.colsName && obj.colsName == "RiskNumber") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "TotalRiskCount" &&
                  item.colsName != "OpenRiskCount" &&
                  item.colsName != "ClosedRiskCount" &&
                  item.colsName != "PreRiskScore" &&
                  item.colsName != "PreWeightedRiskScore"&& item.colsName != "RiskFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "RiskTitle") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "TotalRiskCount" &&
                  item.colsName != "OpenRiskCount" &&
                  item.colsName != "ClosedRiskCount" &&
                  item.colsName != "PreRiskScore" &&
                  item.colsName != "PreWeightedRiskScore"&& item.colsName != "RiskFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "RiskTypeName") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "Frequency" &&
                  item.colsName != "PreRiskScore" &&
                  item.colsName != "PreWeightedRiskScore"&& item.colsName != "RiskFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "UnitName") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "Frequency" &&
                  item.colsName != "PreRiskScore" &&
                  item.colsName != "PreWeightedRiskScore"&& item.colsName != "RiskFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "Owner") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "Frequency" &&
                  item.colsName != "PreRiskScore" &&
                  item.colsName != "PreWeightedRiskScore"&& item.colsName != "RiskFieldsCompletion"
              );
            } else {
              if (this.state.widgetName == "HEAT_MAP") {
                yaxis = this.state.heatmapCols;
              } else {
                yaxis = this.state.impactWithCountCols;
              }
            }
          } else {
            if (obj.colsName && obj.colsName == "RiskNumber") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "TotalRiskCount" &&
                  item.colsName != "OpenRiskCount" &&
                  item.colsName != "ClosedRiskCount"&& item.colsName != "RiskFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "RiskTitle") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) =>
                  item.colsName != "TotalRiskCount" &&
                  item.colsName != "OpenRiskCount" &&
                  item.colsName != "ClosedRiskCount"&& item.colsName != "RiskFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "RiskTypeName") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) => item.colsName != "Frequency" && item.colsName != "RiskFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "UnitName") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) => item.colsName != "Frequency" && item.colsName != "RiskFieldsCompletion"
              );
            } else if (obj.colsName && obj.colsName == "Owner") {
              yaxis = this.state.yAxisColumnsList.filter(
                (item) => item.colsName != "Frequency"&& item.colsName != "RiskFieldsCompletion"
              );
            } else {
              if (this.state.widgetName == "HEAT_MAP") {
                yaxis = this.state.heatmapCols;
              } else {
                yaxis = this.state.impactWithCountCols;
              }
            }
          }
        }
      }
      if (this.state.widgetName === "TRENDING_CHART") {
        temp = this.state.trendYAxis;
      } else if (this.state.widgetName !== "HEAT_MAP") {
        temp = yaxis.filter((item) => item.displayName !== "All Impacts");
      } else {
        temp = yaxis;
      }

      if(this.state.IsTimestamp===true){
        temp=temp.filter((item)=>item.colsName != "ActionFieldsCompletion"&&item.colsName != "RiskFieldsCompletion")
      }
    } catch (error) {}
    return temp;
  };
  getSelectedIds = (ids) => {
    this.setState({
      ...this.state,
      selectedActionIds: ids,
    });
  };

  getTaskSelectedIds = (ids) => {
    this.setState({
      ...this.state,
      selectedTaskIds: ids,
    });
  };

  getSubTaskSelectedIds = (ids) => {
    this.setState({
      ...this.state,
      selectedSubTaskIds: ids,
    });
  };

  convertStrToHash = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      let char = str.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash;
    }
    hash = Math.abs(hash).toString();
    return hash;
  };

  getRiskTypeList = async () => {
    var typeList = [];
    var typeListMiti = [];
    try {
      let response = await Api.getRiskType();
      if (response.status === 200 && response.riskTypes) {
        for (var i = 0; i < response.riskTypes.length; i++) {
          if (response.riskTypes[i].name && response.riskTypes[i].name !== "") {
            typeList.push({
              id: response.riskTypes[i].riskTypeId,
              name: response.riskTypes[i].name,
              checked: false,
              hashValue: this.convertStrToHash(response.riskTypes[i].name),
            });
            typeListMiti.push({
              id: response.riskTypes[i].riskTypeId,
              name: response.riskTypes[i].name,
              checked: false,
              hashValue: this.convertStrToHash(response.riskTypes[i].name),
            });
          }
        }
        let newFirstElement = {
          value: "undefined",
          text: "undefined",
          id: 0,
          name: " [blank]",
          checked: false,
          hashValue: "undefined",
        };
        typeList = [newFirstElement].concat(typeList);
        typeListMiti = [newFirstElement].concat(typeListMiti);
        this.setState({
          ...this.state,
          riskTypemaster: [...typeList],
          riskTypemasterMiti: typeListMiti,
        });
      }
      // console.clear();
    } catch (error) {
      console.error(error);
    }
  };
  getCustomField = async () => {
    let res = [];
    try {
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };

      let response = await Api.getCustomField(request);
      if (response.status === 200) {
        response.customFields.map((item) => {
          item.cfPossibleValues.map((item1) => {
            item1["hashValue"] = this.convertStrToHash(item1.possibleValues);
          });
          if (item.inputType == "Multi Drop Down") {
            let newFirstElement = {
              hashValue: "",
              id: 0,
              possibleValues: " [blank]",
            };

            item["cfPossibleValues"] = [newFirstElement].concat(
              item.cfPossibleValues
            );
            item["possibleValues"] = [" [blank]"].concat(item.possibleValues);
          }
        });

        this.setState({
          ...this.state,
          customFieldsmaster: [...response.customFields],
          customFieldsmasterMiti: [...response.customFields],
        });
      }
    } catch (err) {
      console.error("Exception:", err);
    }
    return res;
  };

  filterChangeV = async (e, colname) => {
    let filteredExisting = [];
    if (this.state.existingFilter) {
      filteredExisting = this.state.existingFilter.filter(filter2 => {
        if (filter2.filters) {
          return !filter2.filters.some(innerFilter => innerFilter.field === colname);
        } else {
          return filter2.field !== colname;
        }
      });
    }

    // Process new filters
    let filter = e ? e.filters : [];
    let newFilters = [];
    if (filter.length > 0) {
      newFilters = [
        {
          filters: filter,
          logic: "or",
        },
      ];
    }

    // Combine filtered existing filters with new filters
    let combinedFilters = [...filteredExisting, ...newFilters];
    
    // Deduplicate the combined filters
    const uniqueFilters = new Set();
    const dedupedFilters = [];
    
    for (const filterItem of combinedFilters) {
      const filterStr = JSON.stringify(filterItem);
      if (!uniqueFilters.has(filterStr)) {
        uniqueFilters.add(filterStr);
        dedupedFilters.push(filterItem);
      }
    }
    const result = filterBy(this.state.riskTemp, dedupedFilters);
    if (result && result.length > 0) {
      await this.createDynamicDropdowns(result, dedupedFilters);
      await this.createDynamicCols(result, dedupedFilters);
      await this.checkRisktypeSelections(dedupedFilters);
    }
    this.setState({
      ...this.state,
      riskList: result,
      existingFilter: dedupedFilters,
      take: 10,//Math.round((window.innerHeight - 250) / 35),
      skip: 0,
      sort: [],
      filter: {
        logic: "and",
        filters: dedupedFilters,
      },
    });
  };

  checkItsinFilterOrNot = (field, exfilter) => {
    try {
      let headerClassName = "";
      if (exfilter) {
        exfilter.map((filter) => {
          if (filter.field === field) {
            headerClassName = "active";
          }
          if (filter.filters) {
            filter.filters.map((innerFilter) => {
              if (innerFilter.field === field) {
                headerClassName = "active";
              }
            });
          }
        });
        return headerClassName;
      }
    } catch (err) {}
  };

  checkCFinFilterValuesOrNot = (field, value, exfilter) => {
    let flag = false;
    try {
      if (exfilter) {
        exfilter.map((filter) => {
          if (filter.field === field && filter.value == value) {
            flag = true;
          }
          if (filter.filters) {
            filter.filters.map((innerFilter) => {
              if (innerFilter.field === field && innerFilter.value == value) {
                flag = true;
              }
            });
          }
        });
      }
    } catch (err) {
      return flag;
    }
    return flag;
  };

  clearFilter = async (e) => {
    try {
      let filter = e ? e : [];
      
      // Deduplicate filters if any exist
      if (filter.length > 0) {
        const uniqueFilters = new Set();
        const dedupedFilters = [];
        
        for (const filterItem of filter) {
          const filterStr = JSON.stringify(filterItem);
          if (!uniqueFilters.has(filterStr)) {
            uniqueFilters.add(filterStr);
            dedupedFilters.push(filterItem);
          }
        }
        
        filter = dedupedFilters;
      }
      
      const result = filterBy(this.state.riskTemp, filter);
      await this.createDynamicDropdowns(result, filter);
      await this.createDynamicCols(result, filter);
      await this.checkRisktypeSelections(filter);
      this.setState({
        ...this.state,
        riskList: result,
        existingFilter: filter,
        take: 10,//Math.round((window.innerHeight - 250) / 35),
        skip: 0,
        sort: [],
        filter: {
          logic: "and",
          filters: filter,
        },
      });
    } catch (err) {
      console.error(err);
    }
  };
  clearFilterNew = async (e) => {
    try {
      let filter = e ? e : [];
      
      // Deduplicate filters if any exist
      if (filter.length > 0) {
        const uniqueFilters = new Set();
        const dedupedFilters = [];
        
        for (const filterItem of filter) {
          const filterStr = JSON.stringify(filterItem);
          if (!uniqueFilters.has(filterStr)) {
            uniqueFilters.add(filterStr);
            dedupedFilters.push(filterItem);
          }
        }
        
        filter = dedupedFilters;
      }
      
      let exi = await this.changeDateValueFromFilters(filter);
      
      // Deduplicate again after date conversion
      if (exi.length > 0) {
        const uniqueFilters = new Set();
        const dedupedFilters = [];
        
        for (const filterItem of exi) {
          const filterStr = JSON.stringify(filterItem);
          if (!uniqueFilters.has(filterStr)) {
            uniqueFilters.add(filterStr);
            dedupedFilters.push(filterItem);
          }
        }
        
        exi = dedupedFilters;
      }
      
      const result = filterBy(this.state.riskTemp, exi);
      await this.createDynamicDropdowns(result, filter);
      await this.createDynamicCols(result, filter);
      await this.checkRisktypeSelections(filter);
      this.setState({
        ...this.state,
        riskList: result,
        existingFilter: filter,
        take: 10,//Math.round((window.innerHeight - 250) / 35),
        sort: [],
        skip: 0,
        filter: {
          logic: "and",
          filters: filter,
        },
      });
    } catch (err) {
      console.error(err);
    }
  };

  changeDateValueFromFilters = (exfilter) => {
    try {
      if (exfilter) {
        exfilter.map((filter) => {
          let flag = moment(
            filter.value,
            "YYYY-MM-DDTHH:mm:ss",
            true
          ).isValid();

          if (flag) {
            filter["value"] = new Date(filter.value);
          }
          if (filter.filters) {
            filter.filters.map((innerFilter) => {
              let flag = moment(
                innerFilter.value,
                "YYYY-MM-DDTHH:mm:ss",
                true
              ).isValid();

              if (flag) {
                innerFilter["value"] = new Date(innerFilter.value);
              }
            });
          }
        });
        return exfilter;
      }
    } catch (err) {
      console.error(err);
    }
    return exfilter;
  };
  filterChangeExisting = async (e) => {
    try {
      if (e.nativeEvent.type === "submit") {
        try {
          let existingFilter = this.state.existingFilter
            ? this.state.existingFilter
            : [];
          let filter = e.filter ? e.filter.filters : [];
          
          // Get the field being filtered from the new filter
          const newFilterFields = new Set();
          if (filter && filter.length > 0) {
            filter.forEach(filterItem => {
              if (filterItem.filters) {
                filterItem.filters.forEach(innerFilter => {
                  if (innerFilter.field) {
                    newFilterFields.add(innerFilter.field);
                  }
                });
              } else if (filterItem.field) {
                newFilterFields.add(filterItem.field);
              }
            });
          }
          
          // Remove any existing filters for the same fields
          let filteredExisting = existingFilter.filter(item => {
            // For filters with nested filters array
            if (item.filters) {
              return !item.filters.some(innerFilter =>
                innerFilter.field && newFilterFields.has(innerFilter.field)
              );
            }
            // For direct filters
            return !(item.field && newFilterFields.has(item.field));
          });
          
          // Combine filtered existing filters with new filters
          let combinedFilters = [...filteredExisting, ...filter];
          
          // Deduplicate the combined filters
          const uniqueFilters = new Set();
          const dedupedFilters = [];
          
          for (const filterItem of combinedFilters) {
            const filterStr = JSON.stringify(filterItem);
            if (!uniqueFilters.has(filterStr)) {
              uniqueFilters.add(filterStr);
              dedupedFilters.push(filterItem);
            }
          }
          const result = filterBy(this.state.riskTemp, dedupedFilters);
          if (result && result.length > 0) {
            await this.createDynamicDropdowns(result, dedupedFilters);
            await this.createDynamicCols(result, dedupedFilters);
            await this.checkRisktypeSelections(dedupedFilters);
          }
          this.setState({
            ...this.state,
            riskList: result,
            existingFilter: dedupedFilters,
            take: 10,//Math.round((window.innerHeight - 250) / 35),
            skip: 0,
            sort: [],
            filter: {
              logic: "and",
              filters: dedupedFilters,
            },
          });
        } catch (err) {
          console.log(err);
        }
      } else if (e.nativeEvent.type === "reset") {
        try {
          let exi = [];
          if (this.state.existingFilter) {
            let filterData = this.state.existingFilter;
            filterData.forEach((filter2) => {
              if (filter2.filters) {
                // Only add the filter if none of its inner filters match the selected column
                const hasMatchingInnerFilter = filter2.filters.some(
                  innerFilter => innerFilter.field === this.state.selectedColumn
                );
                if (!hasMatchingInnerFilter) {
                  exi.push(filter2);
                }
              } else {
                if (filter2.field !== this.state.selectedColumn) {
                  exi.push(filter2);
                }
              }
            });
          }
          const result = filterBy(this.state.riskTemp, exi);
          await this.createDynamicDropdowns(result, exi);
          await this.createDynamicCols(result, exi);
          await this.checkRisktypeSelections(exi);
          this.setState(
            {
              ...this.state,
              riskList: result,
              existingFilter: exi,
              take: 10,//Math.round((window.innerHeight - 250) / 35),
              skip: 0,
              sort: [],
              filter: {
                logic: "and",
                filters: exi,
              },
            },
            console.log(result.length)
          );
        } catch (err) {
          console.log(err);
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  getSelectedColumn = (col) => {
    if (col !== this.state.selectedColumn) {
      this.setState({ ...this.state, selectedColumn: col });
    }
  };

  pageChange = (event) => {
    this.setState({
      skip: event.page.skip,
      take: event.page.take,
    });
  };

  sortChange = (event) => {
    this.setState({
      riskList: this.getProducts(event.sort),
      sort: event.sort,
    });
  };
  getProducts = (sort) => {
    return orderBy(this.state.finalRiskList, sort);
  };

  viewMultiselectColsCustomDropdown = (event, cfObj) => {
    let data = cfObj.data;
    let value = event.dataItem[event.field];

    if (cfObj && cfObj.inputType === "Multi Drop Down") {
      let temp = [];
      if (value && value.includes(",")) {
        let arr = value.split(",");
        arr &&
          arr.map((item1, i) => {
            let originalValue = data.find((item) => item.hashValue === item1);
            if (originalValue) {
              temp.push(originalValue.name);
            }
          });
      } else {
        // let originalValue = data.find((item) => item.hashValue === value&&item.possibleValues=="[blank]");
        let originalValue = data.find((item) => item.hashValue === value);
        if (originalValue && originalValue.name != " [blank]") {
          temp.push(originalValue.name);
        }
      }
      return <td title={temp.toString()}>{temp.toString()}</td>;
    } else if (cfObj && cfObj.inputType === "Single Drop Down") {
      return (
        <td title={value ? value.toString() : ""}>
          {value ? value.toString() : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Free Text") {
      return (
        <td title={value ? value.toString() : ""}>
          {value ? value.toString() : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Numeric") {
      return (
        <td
          title={
            value || value === 0 ? formatNumber(parseInt(value), "##,#") : ""
          }
        >
          {value || value === 0 ? formatNumber(parseInt(value), "##,#") : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Date") {
      return (
        <td title={value ? moment(value).format("DD-MMM-YYYY") : ""}>
          {value ? moment(value).format("DD-MMM-YYYY") : ""}
        </td>
      );
    } else {
      return <td></td>;
    }
  };

  viewMultiselectColsRiskType = (event) => {
    let value = event.dataItem[event.field];
    let temp = [];

    if (value && value.includes(",")) {
      let arr = value.split(",");
      arr &&
        arr.map((item1, i) => {
          let originalValue = this.state.riskTypemaster.find(
            (item) => item.hashValue === item1
          );
          if (originalValue) {
            temp.push(originalValue.name);
          }
        });
    } else {
      let originalValue = this.state.riskTypemaster.find(
        (item) => item.hashValue === value
      );
      if (originalValue && originalValue.name != " [blank]") {
        temp.push(originalValue.name);
      }
    }
    return <td title={temp.toString()}>{temp.toString()}</td>;
  };

  ToggleActionDataset = () => {
    this.setState({ showActionDataSet: !this.state.showActionDataSet });
  };
  ToggleRiskDataset = () => {
    this.setState({ showRiskDataSet: !this.state.showRiskDataSet });
  };
  ToggleTaskDataset = () => {
    this.setState({ showTaskDataSet: !this.state.showTaskDataSet });
  };

  ToggleSubTaskDataset = () => {
    this.setState({ showSubTaskDataSet: !this.state.showSubTaskDataSet });
  };

  getMitigationViewAxis = async () => {
    try {
      var loginUserId = secureLocalStorage.getItem("loginUserId");
      var request = {
        CreatedBy: parseInt(loginUserId),
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.getMitigationViewAxis(request);
      if (response.status === 200) {
        var datasource = response.datasource;
        this.setState({
          ...this.state,
          MitigationDatasourceList: datasource,
          MitigationDatasourceListTemp: datasource,
          loader: false,
        });
      } else {
        this.setState({
          ...this.state,
          loader: false,
          MitigationDatasourceList: [],
          MitigationDatasourceListTemp: [],
        });
      }
    } catch (error) {
      this.setState({
        ...this.state,
        loader: false,
        MitigationDatasourceList: [],
      });
      console.error(error);
    }
  };
  getRiskDataSource = async () => {
    try {
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        Type: "Risk",
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.getView(request);
      if (response.status === 200) {
        var datasource = response.datasource.filter(x => !x.isParent);
        var parentDatasource = response.datasource.filter(x => x.isParent);
        this.setState({
          ...this.state,
          riskDatasetList: datasource,
          riskDatasetListTemp: datasource,
          parentRiskDatasetList: parentDatasource,
          loader: false,
        });
      } else {
        this.setState({ ...this.state, loader: false });
      }
      // console.clear();
    } catch (error) {
      this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };

  getTaskDatasetList = async () => {
    try {
      this.setState({ ...this.state, loader: true });
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };
      let response = await Api.getTaskDatasetList(request);
      if (response.status === 200) {
        var datasource = response.datasource.filter(x => !x.isParent);
        var parentDatasource = response.datasource.filter(x => x.isParent);
        this.setState({
          ...this.state,
          taskDatasetList: datasource,
          parentTaskDatasetList: parentDatasource,
          loader: false,
        });
      } else {
        this.setState({ ...this.state, loader: false,taskDatasetList:[] });
      }
      // console.clear();
    } catch (error) {
      this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };
  getTaskActionDatasetList = async () => {
    try {
      this.setState({ ...this.state, loader: true });
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };
      let response = await Api.getTaskActionDatasetList(request);
      if (response.status === 200) {
        var datasource = response.datasource;
        this.setState({
          ...this.state,
          subTaskDatasetList: datasource,
          loader: false,
        });
      } else {
        this.setState({ ...this.state, loader: false,subTaskDatasetList:[] });
      }
      // console.clear();
    } catch (error) {
      this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };

  resolveField = (fieldName, type, list) => {
  if (!fieldName || !list?.length) return null;
  return list.find(
    f => f.name === fieldName && f.type === type
  ) || null;
};

  selectViewAction = async (data, flag) => {
  try {
      this.setState({ viewType: flag, viewFlag: flag, isDatasetMode: true });

    if (this.state.customFieldsmaster.length === 0) {
      await this.getRiskTypeList();
      await this.getCustomField();
    }

    let field = await this.filterImpactFromFieldList(data.field, data.type);
    switch (flag) {
      case "MITI":
      case "ACTION":
          this.setState({ selected: 0, filteredRiskIds:[] });
        const parentDataset = this.state.parentRiskDatasetList.find(parent => parent.id === data.parentViewId);
        
        await this.getRiskDataByViewId(parentDataset);
        await this.getAllImpactThresholdForDataset("risk");

        await this.getActionDataByViewId(data);
        await this.getAllImpactThresholdForDataset("action");

        const parentSelectedField = this.resolveField(
          parentDataset.field,
          parentDataset.type,
          this.state.parentFieldList
        );

        const actSelectedField = this.resolveField(
          data.field,
          data.type,
          this.state.fieldList
        );

        this.setState({
          actSelectedTopBottom: data.topOrBottom,
          actSelectedNumber: data.topOrBottomCount,
          actSelectedField,
          date_impact: data.topxType || "None",
          mode_value: data.topxDateMode,
          days_value: data.topxDateCount,
          datefield_value: this.state.dateFieldList.find(
            (item) => item.name === data.topxDateField
          ),
          parentSelectedTopBottom: parentDataset.topOrBottom,
          parentSelectedNumber: parentDataset.topOrBottomCount,
          parentSelectedField,
          parent_date_impact: parentDataset.topxType || "None",
          parent_mode_value: parentDataset.topxDateMode,
          parent_days_value: parentDataset.topxDateCount,
          parent_datefield_value: this.state.parentDateFieldList.find(
            (item) => item.name === parentDataset.topxDateField
          ),
        });

        break;

      case "RISK":
          this.setState({ selected: 0 });

        await this.getRiskDataByViewId(data);
        await this.getAllImpactThresholdForDataset("risk");
        const riskSelectedField = this.resolveField(
          data.field,
          data.type,
          this.state.parentFieldList
        );
        this.setState({
          parentSelectedTopBottom: data.topOrBottom,
          parentSelectedNumber: data.topOrBottomCount,
          parentSelectedField: riskSelectedField,
          parent_date_impact: data.topxType || "None",
          parent_mode_value: data.topxDateMode,
          parent_days_value: data.topxDateCount,
          parent_datefield_value: this.state.parentDateFieldList.find(
            (item) => item.name === data.topxDateField
          ),
        });
        break;

      case "TASK":
        this.setState({ selected: 1 });

        await this.getFieldsForDataset("Task");

        if (this.refs.childTask) {
          await this.refs.childTask.getTaskDatasetView(data);
        }
        const taskSelectedField = this.resolveField(
          data.field,
          data.type,
          this.state.parentFieldList
        );
        this.setState({
          parentSelectedTopBottom: data.topOrBottom,
          parentSelectedNumber: data.topOrBottomCount,
          parentSelectedField: taskSelectedField,
          parent_date_impact: data.topxType || "None",
          parent_mode_value: data.topxDateMode,
          parent_days_value: data.topxDateCount,
          parent_datefield_value: this.state.parentDateFieldList.find(
            (item) => item.name === data.topxDateField
          ),
        });
        break;

      case "SUBTASK":
        this.setState({ selected: 1 });

        const activityParentDataset = this.state.parentTaskDatasetList.find(parent => parent.id === data.parentViewId);
        if (this.refs.childTask) {
          await this.refs.childTask.getTaskDatasetView(activityParentDataset);
        }
        await this.getFieldsForDataset("Task");

        await this.getFieldsForDataset("TaskAction");
        if (this.refs.childSubTask) {
          await this.refs.childSubTask.getTaskActionDatasetView(data);
        }

        const actParentSelectedField = this.resolveField(
          activityParentDataset.field,
          activityParentDataset.type,
          this.state.parentFieldList
        );

        const activitySelectedField = this.resolveField(
          data.field,
          data.type,
          this.state.fieldList
        );

        this.setState({
          actSelectedTopBottom: data.topOrBottom,
          actSelectedNumber: data.topOrBottomCount,
          actSelectedField: activitySelectedField,
          date_impact: data.topxType || "None",
          mode_value: data.topxDateMode,
          days_value: data.topxDateCount,
          datefield_value: this.state.dateFieldList.find(
            (item) => item.name === data.topxDateField
          ),
          parentSelectedTopBottom: activityParentDataset.topOrBottom,
          parentSelectedNumber: activityParentDataset.topOrBottomCount,
          parentSelectedField : actParentSelectedField,
          parent_date_impact: activityParentDataset.topxType || "None",
          parent_mode_value: activityParentDataset.topxDateMode,
          parent_days_value: activityParentDataset.topxDateCount,
          parent_datefield_value: this.state.parentDateFieldList.find(
            (item) => item.name === activityParentDataset.topxDateField
          ),
        });
        break;

      default:
        break;
    }
    
    let fieldMissingMsg = "";
    if (data.field && !field) {
      fieldMissingMsg = "Field Name " + data.field + " missing in field list";
    }
    let primeHideFlag = secureLocalStorage.getItem("isPrime") == true ? true : false;
    mapTree(this.state.data, "children", (item) => {
      if (this.state.OrgUnitIds.includes(item.unitId)) {
        if (!item.isPrime) {
          primeHideFlag = item.isPrime;
        }
      }
      return item;
    });
    this.setState((prev) => ({
      ...prev,
      viewId: data.id,
      editFlag: true,
      Name: data.name,
      description: data.description,
      fieldMissingMsg,
      IsWorkstreamchanged: false,
      primeHideFlag: primeHideFlag,
      createdDate: data.createdDate,
      updatedDate: data.updatedDate,
      parentViewId: data.parentViewId
    }));

  } catch (error) {
    console.error("Error in selectViewAction:", error);
  }
};


  workstreamIdpopulation=(wsId)=>{
    this.setState({...this.state,OrgUnitIds:wsId})
    this.refs.child.refreshData(Array.from(new Set(wsId)));
  }
  filterImpactFromFieldList = (name, type) => {
    const fieldList = this.state.viewType === "RISK"
      ? this.state.parentFieldList 
      : this.state.fieldList;
    return fieldList.find(
      (item) => item.name === name && item.type === type
    );
    
  };

  openDeletePopup = (data) => {
    this.setState({
      ...this.state,
      openDeleteModelFlagView: true,
      viewData: data,
    });
  };
  closeDeletePopup = () => {
    this.setState({
      ...this.state,
      openDeleteModelFlagView: false,
    });
  };
  removeView = async () => {
    try {
      const requestParams = {
        DeletedBy: this.state.viewData.id,
      };

      this.setState({ ...this.state, loader: true });
      let response = await Api.deleteView(requestParams);
      if (response.status === 200) {
        this.setState({ ...this.state, loader: false });
        toastr.success(response.message);
        this.closeDeletePopup();
        this.getMitigationViewAxis();
        this.getRiskDataSource();
        this.getTaskDatasetList();
    this.getTaskActionDatasetList();
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
      // console.clear();
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };

  refreshPage = () => {
    window.location.reload();
  };

  isExistName = async (e) => {
    try {
      if (e.target.value == "") {
        return;
      }
      let request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        Name: e.target.value,
      };
      let response = await Api.widgetDuplicationCheck(request);
      if (response.status === 200) {
        this.setState({ ...this.state, isNameExist: false });
      } else {
        this.setState({
          ...this.state,
          isNameExist: true,
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  enterEdit = () => {};

  openAddToCart(data, type) {
    this.setState({
      showAddToCart: true,
      cartViewDetails: data,
      cartViewType: type,
    });
  }
  closeAddToCart() {
    this.setState({ showAddToCart: false });
  }

  goToReport = (dashBoardId) => {
    // let ccc = document.getElementById("reportActiveLink").click();
    secureLocalStorage.setItem("ActivePage", "Reports");
    const token =
      secureLocalStorage.getItem("loggedClient") === "user"
        ? secureLocalStorage.getItem("userKey")
        : secureLocalStorage.getItem("tenantKey");
    const loggedClient = secureLocalStorage.getItem("loggedClient");
    this.props.history.push({
      pathname: `/${loggedClient}/${token}/home/dashboard/reports`,
      dashBoardId: dashBoardId,
    });
  };
  selectDataset = async (e) => {
    this.setState({
      ...this.state,
      datasource: e.target.value,
    });
    if (e.target.value) {
      this.setState((prevState) => ({
        widgetError: {
          ...prevState.widgetError,
          widgetDataSet: false,
        },
      }));
    } else {
      this.setState((prevState) => ({
        widgetError: {
          ...prevState.widgetError,
          widgetDataSet: true,
        },
      }));
    }
    await this.getAxisFromDataset(e.target.value);
  };

  getAxisFromDataset = (ds) => {
    let heatmapCols = ds.yAxis
      ? ds.yAxis.filter(
          (item) =>
            item.colsName != "PreWeightedRiskScore" &&
            item.colsName != "PreRiskScore" &&
            item.colsName != "OpenRiskCount" &&
            item.colsName != "TotalRiskCount" &&
            item.colsName != "ClosedRiskCount"
        )
      : [];

    if (this.state.viewFlag === "RISK") {
      this.setState({
        ...this.state,
        xAxisColumnsList: ds.xAxis
          ? [...this.state.xAxisColumnsListTemp, ...ds.xAxis]
          : this.state.xAxisColumnsListTemp,
        yAxisColumnsList: ds.yAxis
          ? [...this.state.yAxisColumnsListTemp, ...ds.yAxis]
          : this.state.yAxisColumnsListTemp,
        timestampXAxisColumns: ds.xAxis
          ? [...this.state.xAxisColumnsListTemp, ...ds.xAxis]
          : this.state.xAxisColumnsListTemp,
        timestampYAxisColumns: ds.yAxis
          ? [...this.state.yAxisColumnsListTemp, ...ds.yAxis]
          : this.state.yAxisColumnsListTemp,
        heatmapCols: heatmapCols,
        impactWithCountCols: ds.yAxis,
        datasource: ds,
        trendYAxis:ds.trendYAxis
      });
    } else {
      this.setState({
        ...this.state,
        xAxisColumnsList: ds.xAxis
          ? [...this.state.xAxisColumnsListTemp, ...ds.xAxis]
          : this.state.xAxisColumnsListTemp,
        // xAxisColumnsList: this.state.xAxisColumnsListTemp
        //  ? this.state.xAxisColumnsListTemp
        //   : [],
        yAxisColumnsList: ds.yAxis
          ? [...this.state.yAxisColumnsListTemp, ...ds.yAxis]
          : this.state.yAxisColumnsListTemp,
        timestampXAxisColumns: this.state.xAxisColumnsListTemp
          ? this.state.xAxisColumnsListTemp
          : [],
        timestampYAxisColumns: ds.yAxis
          ? [...this.state.yAxisColumnsListTemp, ...ds.yAxis]
          : this.state.yAxisColumnsListTemp,
        heatmapCols: heatmapCols,
        impactWithCountCols: ds.yAxis,
        datasource: ds,
        trendYAxis:ds.trendYAxis
      });
    }
  };

  getImpactListValues = () => {
    var temp = [];
    try {
      var tempList =
        this.state.widgetName === "HEAT_MAP" ||
        this.state.widgetName === "MONTE_CARLO"
          ? this.state.widgetName === "MONTE_CARLO"
            ? this.state.heatmapCols.filter(
                (item) => !item.colsName.startsWith("QImpact$$")
              )
            : this.state.heatmapCols
          : this.state.xAxisColumnsList;

      if (this.state.widgetName !== "HEAT_MAP") {
        temp = tempList.filter((item) => item.displayName !== "All Impacts");
      } else {
        temp = tempList;
      }
    } catch (error) {}
    return temp;
  };

  progressHistory = (dataItem) => {
    this.setState({ ...this.state, progressStatusFlag: true,riskImpactComments: dataItem.riskImpactComments});
  };

  closeProgressHistoryPopup = () => {
    this.setState({ ...this.state, progressStatusFlag: false,riskImpactComments: []});
  };

  renderDatasetSection = () => {
    return (
      <>
        <div className="row">
          <div className="col-xs-6 col-sm-6">
            <div className="formControl">
              <label>Dataset Name *</label>
              <input
                type="text"
                required
                value={this.state.Name}
                onChange={(e) =>
                  this.setState({ Name: e.target.value })
                }
              />
            </div>
            {this.state.viewId && (
              <div className="row" style={{ marginTop: "10px" }}>
                <div className="col-xs-6 col-sm-6">
                  <div className="formControl">
                    <label>Created Date</label>
                    <div className="date-value">
                      {this.state.createdDate ? moment(this.state.createdDate).format("DD-MMM-YYYY HH:mm") : null}
                    </div>
                  </div>
                </div>
                <div className="col-xs-6 col-sm-6">
                  <div className="formControl">
                    <label>Updated Date</label>
                    <div className="date-value">
                      {this.state.updatedDate ? moment(this.state.updatedDate).format("DD-MMM-YYYY HH:mm") : null}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="col-xs-6 col-sm-6">
            <div className="formControl">
              <label>Description</label>
              <textarea
                value={this.state.description}
                onChange={(e) =>
                  this.setState({ description: e.target.value })
                }
                rows="4"
                className="description-textarea"
                style={{
                  backgroundColor: "#313535",
                  color: "rgba(255, 255, 255, 0.8)",
                  border: "none",
                  borderRadius: "4px",
                  height: "85px"
                }}
              />
            </div>
          </div>
        </div>
       
      </>
    )
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.selected) {
      this.riskFilterTopX(prevProps, prevState);
    }
  };

  riskFilterTopX = (prevProps, prevState) => {
    if (
      prevState.riskList !== this.state.riskList ||
      prevState.parentSelectedField !== this.state.parentSelectedField ||
      prevState.parent_date_impact !== this.state.parent_date_impact ||
      prevState.parentSelectedTopBottom !== this.state.parentSelectedTopBottom ||
      prevState.parentSelectedNumber !== this.state.parentSelectedNumber ||
      prevState.parent_days_value !== this.state.parent_days_value ||
      prevState.parent_datefield_value !== this.state.parent_datefield_value ||
      prevState.parent_mode_value !== this.state.parent_mode_value
    ) {
      const filteredRiskIds = [];
      const finalRiskList = this.applyTopXFilter(this.state.riskList, "RISK");
      if (finalRiskList && finalRiskList.length > 0) {
        filteredRiskIds.push(
          ...finalRiskList.map(item => item.riskRegisterId)
        );
      }
      this.setState({ finalRiskList, filteredRiskIds, skip: 0 });
    }
  };

applyTopXFilter = (data, entityType) => {
  const config = this.getTopXConfig(entityType);
  const type = this.state[config.typeKey];

  if (!type || type === "None") {
    return data;
  }

  if (type === "Date") {
    return this.applyDateFilter(data, config);
  }

  if (type === "Impact") {
    return this.applyValueFilter(data, config);
  }

  return data;
};

  applyDateFilter = (data, config) => {
    const mode = this.state[config.modeKey];
    const days = Number(this.state[config.daysKey]);
    const dateField = this.state[config.dateFieldKey];

    if (!days || !dateField) return data;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const dateRange = new Date(today);
    dateRange.setDate(
      mode === "Backward" || mode === "Back Beyond"
        ? today.getDate() - days
        : today.getDate() + days
    );

    return data
      .filter(item => {
        const rawDate = item[dateField.topXFilterName];
        if (!rawDate) return false;

        const targetDate = new Date(rawDate);
        targetDate.setHours(0, 0, 0, 0);

        if (mode === "Backward") {
          return targetDate > dateRange && targetDate <= today;
        }

        if (mode === "Back Beyond") {
          return targetDate < dateRange;
        }

        return targetDate < dateRange && targetDate >= today;
      })
      .sort((a, b) => {
        const da = new Date(a[dateField.topXFilterName]);
        const db = new Date(b[dateField.topXFilterName]);
        return da - db;
      });
  };

 applyValueFilter = (data, config) => {
  const position = this.state[config.positionKey];
  const count = Number(this.state[config.numberKey]);
  const fieldObj = this.state[config.fieldKey];

  if (!position || !count || !fieldObj) return data;

  const fieldName = fieldObj.topXFilterName;

  const sorted = [...data].sort((a, b) => {
    const av = Number(a[fieldName]);
    const bv = Number(b[fieldName]);

    if (isNaN(av) && isNaN(bv)) return 0;
    if (isNaN(av)) return 1;
    if (isNaN(bv)) return -1;

    return position === "Top"
      ? bv - av   // Descending
      : av - bv;  // Ascending
  });

  if (!sorted.length) return [];

  if (count >= sorted.length) return sorted;

  const cutoffValue = Number(sorted[count - 1][fieldName]);

  return sorted.filter(item => {
    const value = Number(item[fieldName]);
    if (isNaN(value)) return false;

    return position === "Top"
      ? value >= cutoffValue
      : value <= cutoffValue;
  });
};
  getTopXConfig = (entityType) => {
    if (entityType === "RISK" || entityType === "ALL" || entityType === "TASK") {
      return {
        label: entityType === "TASK" ? "Task" : "Risk",
        dateFieldList: this.state.parentDateFieldList,
        fieldList: this.state.parentFieldList,
        topBottomList: this.state.topBottomList,

        modeKey: "parent_mode_value",
        daysKey: "parent_days_value",
        dateFieldKey: "parent_datefield_value",

        positionKey: "parentSelectedTopBottom",
        numberKey: "parentSelectedNumber",
        fieldKey: "parentSelectedField",

        typeKey: "parent_date_impact"
      };
    }

    return {
      label: entityType === "ACTION" ? "Action" : "Activity",
      dateFieldList: this.state.dateFieldList,
      fieldList: this.state.fieldList,
      topBottomList: this.state.topBottomList,

      modeKey: "mode_value",
      daysKey: "days_value",
      dateFieldKey: "datefield_value",

      positionKey: "actSelectedTopBottom",
      numberKey: "actSelectedNumber",
      fieldKey: "actSelectedField",

      typeKey: "date_impact"
    };
  };


  renderTopXDataset = (entityType) => {
  const config = this.getTopXConfig(entityType);
  const typeValue = this.state[config.typeKey];

  return (
    <div className="selection-section">
      <div className="row">

        {/* Selection Type */}
        <div className="col-xs-3 col-sm-3" style={{ minWidth: "200px" }}>
          <div className="formControl">
            <label>{config.label} Selection Type</label>
            <div className="dBlockCont">
              <DropDownList
                data={["None", "Date selection", "Value selection"]}
                value={
                  typeValue === "None"
                    ? "None"
                    : typeValue === "Date"
                    ? "Date selection"
                    : "Value selection"
                }
                onChange={(e) => {
                  const v = e.target.value;
                  this.setState({
                    [config.typeKey]:
                      v === "None" ? "None" :
                      v === "Date selection" ? "Date" : "Impact"
                  });
                }}
              />
            </div>
          </div>
        </div>

        {/* Date Selection */}
        {typeValue === "Date" && (
          <>
            <div className="col-xs-3 col-sm-3">
              <div className="formControl">
                <label>Mode *</label>
                <div className="dBlockCont">
                  <DropDownList
                    data={["Forward", "Backward", "Back Beyond"]}
                    value={this.state[config.modeKey]}
                    onChange={(e) =>
                      this.setState({ [config.modeKey]: e.target.value })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="col-xs-3 col-sm-3">
              <div className="formControl">
                <label>Number Of Days *</label>
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  value={this.state[config.daysKey]}
                  onChange={(e) => {
                    const v = e.target.value.replace(/\D/g, "");
                    this.setState({ [config.daysKey]: v });
                  }}
                />
              </div>
            </div>

            <div className="col-xs-3 col-sm-3">
              <div className="formControl">
                <label>Date Field *</label>
                <div className="dBlockCont">
                  <DropDownList
                    data={config.dateFieldList || []}
                    value={this.state[config.dateFieldKey]}
                    textField="displayName"
                    onChange={(e) =>
                      this.setState({ [config.dateFieldKey]: e.target.value })
                    }
                  />
                </div>
              </div>
            </div>
          </>
        )}

        {/* Value Selection */}
        {typeValue === "Impact" && (
          <>
            <div className="col-xs-3 col-sm-3">
              <div className="formControl">
                <label>Position *</label>
                <div className="dBlockCont">
                  <DropDownList
                    data={config.topBottomList}
                    value={this.state[config.positionKey]}
                    onChange={(e) =>
                      this.setState({ [config.positionKey]: e.target.value })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="col-xs-3 col-sm-3">
              <div className="formControl">
                <label>Number Value *</label>
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  value={this.state[config.numberKey]}
                  onChange={(e) => {
                    const v = e.target.value.replace(/\D/g, "");
                    this.setState({ [config.numberKey]: v });
                  }}
                />
              </div>
            </div>

            <div className="col-xs-3 col-sm-3">
              <div className="formControl">
                <label>Field *</label>
                <div className="dBlockCont">
                  <DropDownList
                    data={config.fieldList || []}
                    value={this.state[config.fieldKey]}
                    textField="displayName"
                    onChange={(e) =>
                      this.setState({ [config.fieldKey]: e.target.value })
                    }
                  />
                </div>
              </div>
            </div>
          </>
        )}

      </div>
    </div>
  );
};


  render() {
    let isPrime = this.state.primeHideFlag;
    return (
      <div className="riskViewCont">
        <div className="rvRow">
          {this.state.loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}
          <div className="sidebar">
            <div className="gbox datasetSidebaContainer">
              <div className="header">
                Workstream
                {/* <a
                  title="Reset page"
                  href="#"
                  className="refreshDataset"
                  onClick={this.refreshPage}
                >
                  <img src={Images.REFRESH} width="10" alt="" />
                </a> */}
              </div>
              <div className="treeView gBoxSelection datasetSidebar">
                <OrganizationTreeList
                  // selectedOrgUnit={this.state.selectedOrgUnit}
                  orgUnitData={this.state.data}
                  getRiskList={this.getAllDataByWorkstream}
                  getEmptyRiskList={this.setEmptyRiskList}
                  ref="child"
                />
              </div>
              <div class="gBoxSelection autoHeight">
                {/* Risk */}
                {this.state.selected == 0 ? (
                  <div className="qdReports">
                    <div className="secHeader pointer">
                      <h5>Risk Datasets</h5>
                      <div className="iconCont">
                        <a
                          onClick={() => this.ToggleRiskDataset()}
                          className={
                            this.state.showRiskDataSet
                              ? "opened arrowIcon"
                              : "arrowIcon"
                          }
                          href="#"
                        >
                          <img src={Images.ARROW} width="10" alt="" />
                        </a>
                      </div>
                    </div>

                    {this.state.showRiskDataSet ? (
                      <div className="viewConts">
                        <div className="listView">
                          <ul>
                            {this.state.riskDatasetList && this.state.riskDatasetList.length > 0 ? (
                              this.state.riskDatasetList.map((data, index) => (
                                <li
                                  className={
                                    data.id === this.state.viewId
                                      ? "active"
                                      : ""
                                  }
                                >
                                  <div class="dbLists">
                                    <span className="statusIcon">
                                      <img
                                        src={
                                          data.scope === 0
                                            ? Images.LOCK
                                            : Images.UNLOCK
                                        }
                                        className="stateIcon"
                                        width="20"
                                      />
                                    </span>
                                    <h5>
                                      <h5
                                        title={
                                          data.description
                                            ? data.description
                                            : "Description not available"
                                        }
                                        style={{ width: "154px" }}
                                        onClick={() =>
                                          this.selectViewAction(data, "RISK")
                                        }
                                      >
                                        {data.name}
                                      </h5>
                                    </h5>
                                    <div class="dbListIcons">
                                      <a
                                        class="iconG"
                                        onClick={() =>
                                          this.openAddToCart(data, "Risk")
                                        }
                                        href="#"
                                      >
                                        <img
                                          src={Images.CART}
                                          className="stateIcon"
                                          width="10"
                                          alt=""
                                        />
                                      </a>
                                      <a
                                        class="iconG"
                                        onClick={() =>
                                          this.openDeletePopup(data)
                                        }
                                        href="#"
                                      >
                                        <img
                                          src={Images.TRASH}
                                          className="stateIcon"
                                          width="12"
                                          alt=""
                                        />
                                      </a>
                                    </div>
                                  </div>
                                </li>
                              ))
                            ) : (
                              <li className="empty">None</li>
                            )}
                          </ul>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                ) : ("")
                }

                {/* Action */}
                {this.state.selected == 0 ? (
                  <div className="qdReports">
                    <div className="secHeader pointer">
                      <h5>Action Datasets</h5>
                      <div className="iconCont">
                        <a
                          onClick={() => this.ToggleActionDataset()}
                          className={
                            this.state.showActionDataSet
                              ? "opened arrowIcon"
                              : "arrowIcon"
                          }
                          href="#"
                        >
                          <img src={Images.ARROW} width="10" alt="" />
                        </a>
                      </div>
                    </div>

                    {this.state.showActionDataSet ? (
                      <div className="viewConts">
                        <div className="listView">
                          <ul>
                            {this.state.MitigationDatasourceList && this.state.MitigationDatasourceList.length > 0 ? (
                              this.state.MitigationDatasourceList.map(
                                (data, index) => (
                                  <li
                                    className={
                                      data.id === this.state.viewId
                                        ? "active"
                                        : ""
                                    }
                                  >
                                    <div class="dbLists">
                                      <span className="statusIcon">
                                        <img
                                          src={
                                            data.scope === 0
                                              ? Images.LOCK
                                              : Images.UNLOCK
                                          }
                                          className="stateIcon"
                                          width="20"
                                        />
                                      </span>
                                      <h5>
                                        <h5
                                          title={
                                            data.description
                                              ? data.description
                                              : "Description not available"
                                          }
                                          style={{ width: "154px" }}
                                          onClick={() =>
                                            this.selectViewAction(
                                              data,
                                              "ACTION"
                                            )
                                          }
                                        >
                                          {data.name}
                                        </h5>
                                      </h5>
                                      <div class="dbListIcons">
                                        <a
                                          class="iconG"
                                          onClick={() =>
                                            this.openAddToCart(
                                              data,
                                              "Mitigation"
                                            )
                                          }
                                          href="#"
                                        >
                                          <img
                                            src={Images.CART}
                                            className="stateIcon"
                                            width="10"
                                            alt=""
                                          />
                                        </a>

                                        <a
                                          class="iconG"
                                          onClick={() =>
                                            this.openDeletePopup(data)
                                          }
                                          href="#"
                                        >
                                          <img
                                            src={Images.TRASH}
                                            className="stateIcon"
                                            width="12"
                                            alt=""
                                          />
                                        </a>
                                      </div>
                                    </div>
                                  </li>
                                ))
                            ) : (
                              <li className="empty">None</li>
                            )}
                          </ul>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                ) : ("")
                }

                {
                  secureLocalStorage.getItem("isTasksModuleEnabled") === true
                    && this.state.selected == 1 ? (
                    <div className="qdReports">
                      <div className="secHeader pointer">
                        <h5>Task Datasets</h5>
                        <div className="iconCont">
                          <a
                            onClick={() => this.ToggleTaskDataset()}
                            className={
                              this.state.showTaskDataSet
                                ? "opened arrowIcon"
                                : "arrowIcon"
                            }
                            href="#"
                          >
                            <img src={Images.ARROW} width="10" alt="" />
                          </a>
                        </div>
                      </div>

                      {this.state.showTaskDataSet ? (
                        <div className="viewConts">
                          <div className="listView">
                            <ul>
                              {this.state.taskDatasetList && this.state.taskDatasetList.length > 0 ? (
                                this.state.taskDatasetList.map((data, index) => (
                                  <li
                                    className={
                                      data.id === this.state.viewId
                                        ? "active"
                                        : ""
                                    }
                                  >
                                    <div class="dbLists">
                                      <span className="statusIcon">
                                        <img
                                          src={
                                            data.scope === 0
                                              ? Images.LOCK
                                              : Images.UNLOCK
                                          }
                                          className="stateIcon"
                                          width="20"
                                        />
                                      </span>
                                      <h5>
                                        <h5
                                          title={
                                            data.description
                                              ? data.description
                                              : "Description not available"
                                          }
                                          style={{ width: "154px" }}
                                          onClick={() =>
                                            this.selectViewAction(data, "TASK")
                                          }
                                        >
                                          {data.name}
                                        </h5>
                                      </h5>
                                      <div class="dbListIcons">
                                        <a
                                          class="iconG"
                                          onClick={() =>
                                            this.openAddToCart(data, "Task")
                                          }
                                          href="#"
                                        >
                                          <img
                                            src={Images.CART}
                                            className="stateIcon"
                                            width="10"
                                            alt=""
                                          />
                                        </a>

                                        <a
                                          class="iconG"
                                          onClick={() =>
                                            this.openDeletePopup(data)
                                          }
                                          href="#"
                                        >
                                          <img
                                            src={Images.TRASH}
                                            className="stateIcon"
                                            width="12"
                                            alt=""
                                          />
                                        </a>
                                      </div>
                                    </div>
                                  </li>
                                ))
                              ) : (
                                <li className="empty">None</li>
                              )}
                            </ul>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : ("")
                }
               
                {
                  secureLocalStorage.getItem("isTasksModuleEnabled") === true
                    && this.state.selected == 1 ? (
                    <div className="qdReports">
                      <div className="secHeader pointer">
                        <h5>Activity Datasets</h5>
                        <div className="iconCont">
                          <a
                            onClick={() => this.ToggleSubTaskDataset()}
                            className={
                              this.state.showSubTaskDataSet
                                ? "opened arrowIcon"
                                : "arrowIcon"
                            }
                            href="#"
                          >
                            <img src={Images.ARROW} width="10" alt="" />
                          </a>
                        </div>
                      </div>

                      {this.state.showSubTaskDataSet ? (
                        <div className="viewConts">
                          <div className="listView">
                            <ul>
                              {this.state.subTaskDatasetList && this.state.subTaskDatasetList.length > 0 ? (
                                this.state.subTaskDatasetList.map((data, index) => (
                                  <li
                                    className={
                                      data.id === this.state.viewId
                                        ? "active"
                                        : ""
                                    }
                                  >
                                    <div class="dbLists">
                                      <span className="statusIcon">
                                        <img
                                          src={
                                            data.scope === 0
                                              ? Images.LOCK
                                              : Images.UNLOCK
                                          }
                                          className="stateIcon"
                                          width="20"
                                        />
                                      </span>
                                      <h5>
                                        <h5
                                          title={
                                            data.description
                                              ? data.description
                                              : "Description not available"
                                          }
                                          style={{ width: "154px" }}
                                          onClick={() =>
                                            this.selectViewAction(data, "SUBTASK")
                                          }
                                        >
                                          {data.name}
                                        </h5>
                                      </h5>
                                      <div class="dbListIcons">
                                        <a
                                          class="iconG"
                                          onClick={() =>
                                            this.openAddToCart(data, "TaskAction")
                                          }
                                          href="#"
                                        >
                                          <img
                                            src={Images.CART}
                                            className="stateIcon"
                                            width="10"
                                            alt=""
                                          />
                                        </a>

                                        <a
                                          class="iconG"
                                          onClick={() =>
                                            this.openDeletePopup(data)
                                          }
                                          href="#"
                                        >
                                          <img
                                            src={Images.TRASH}
                                            className="stateIcon"
                                            width="12"
                                            alt=""
                                          />
                                        </a>
                                      </div>
                                    </div>
                                  </li>
                                ))
                              ) : (
                                <li className="empty">None</li>
                              )}
                            </ul>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : ("")
                }
               
              </div>
            </div>
          </div>
          <div className="riskConts">
            <div className="custom-tabs">
              <div className="custom-tabs-header">
                {!this.state.viewId && !this.state.isDatasetMode && (
                  <div className="tabs-left">
                    <div
                      className={`custom-tab ${this.state.selected === 0 ? 'active' : ''}`}
                      onClick={() => this.handleSelect(0)}
                    >
                      Risks
                    </div>
                    {secureLocalStorage.getItem("isTasksModuleEnabled") === true && (
                      <div
                        className={`custom-tab ${this.state.selected === 1 ? 'active' : ''}`}
                        onClick={() => this.handleSelect(1)}
                      >
                        Tasks
                      </div>
                    )}
                  </div>
                )}
                {this.state.isDatasetMode && (
                  this.state.viewType === "RISK" ? (
                    <div className="tabs-left custom-tab">
                      Risk Dataset
                    </div>
                  ) : this.state.viewType === "ACTION" ? (
                    <div className="tabs-left custom-tab">
                      Action Dataset
                    </div>
                  ) : null
                )}
                {secureLocalStorage.getItem("isTasksModuleEnabled") === true &&
                  this.state.isDatasetMode && (
                    this.state.viewType === "TASK" ? (
                      <div className="tabs-left custom-tab">
                        Task Dataset
                      </div>
                    ) : this.state.viewType === "SUBTASK" ? (
                      <div className="tabs-left custom-tab">
                        Activity Dataset
                      </div>
                    ) : null
                  )}

                <div className="tabs-right">
                  {this.state.isDatasetMode && (
                      <button className="restart-button"
                      disabled={this.getSubmitValidations()}
                      onClick={this.saveQuery}
                      >Save</button>
                  )}
                  <button
                    className="restart-button"
                    onClick={this.refreshPage}
                  >
                    Restart Selection
                  </button>
                </div>
              </div>
              <div className="custom-tabs-content">
                <div className="tab-content-wrapper">
                  {this.state.isDatasetMode && (
                    <div className="createDashboardDialog" ref={this.myRef}>
                      {this.renderDatasetSection()}
                      {this.renderTopXDataset(this.state.selected === 0 ? "RISK" : "TASK")}
                    </div>
                  )}
                  {this.state.selected === 0 &&
                    (this.state.viewType === "RISK" || this.state.viewType === "ACTION" ||
                      this.state.viewType === "ALL") && (
                      <>
                        <div className="gbox marginBtm10" id="rw-tab-header">
                          <div className="header">
                            <h5>
                              Risks
                            </h5>
                            <ul>
                              {this.state.OrgUnitIds &&
                                this.state.OrgUnitIds.length > 0 &&
                                this.state.isDatasetMode === false && (
                                  <li onClick={() => this.startCreateDataset("RISK")}>
                                    <button>
                                      Create Risk Dataset
                                    </button>
                                  </li>
                                )}
                            </ul>
                          </div>
                          <div
                            className="tblCont riskRegister dataGrids ActionTbl"
                            id="riskdataset"
                          >
                            <Grid
                              style={{ minHeight: "100px" }}
                              data={(() => {
                                let filteredData = filterBy(this.state.finalRiskList, this.state.filter);
                                if (this.state.sort && this.state.sort.length > 0) {
                                  filteredData = orderBy(filteredData, this.state.sort);
                                }
                                return filteredData.slice(this.state.skip, this.state.take + this.state.skip);
                              })()}
                              reorderable={this.state.finalRiskList.length == 0 ? false : true}
                              resizable={this.state.finalRiskList.length == 0 ? false : true}
                              // expandField="expanded"
                              // onExpandChange={this.expandChange}
                              // detail={MitigationDetails}
                              {...this.state.dataState}
                              onDataStateChange={this.dataStateChange}
                              selectedField="selected"
                              onSelectionChange={this.selectionChange}
                              onHeaderSelectionChange={this.headerSelectionChange}
                              filterOperators={filterOperators}
                              // onRowClick={this.rowClick}
                              // sortable={true}
                              pageable={true}
                              // total={this.state.riskList.length}
                              sortable={{
                                allowUnsort: true,
                                mode: "multiple",
                              }}
                              sort={this.state.sort}
                              onSortChange={this.sortChange}
                              total={(() => {
                                let filteredData = filterBy(this.state.finalRiskList, this.state.filter);
                                if (this.state.sort && this.state.sort.length > 0) {
                                  filteredData = orderBy(filteredData, this.state.sort);
                                }
                                return filteredData.length;
                              })()}
                              skip={this.state.skip}
                              take={this.state.take}
                              onPageChange={this.pageChange}
                              // filterable={true}
                              // filter={this.state.filter?this.state.filter:{}}
                              onFilterChange={this.filterChangeExisting}
                              filter={this.state.filter}
                            // onFilterChange={(e) => {
                            //   this.setState({
                            //     filter: e.filter,
                            //   });
                            // }}
                            >
                              <GridNoRecords>
                                {this.state.notValidPrimeDataset
                                  ? "Cannot load dataset as Prime settings have been changed for Tenant or Workstream"
                                  : this.state.isCustomFieldDeleted
                                    ? "Associated Dataset's Custom fields might been deleted or revoked"
                                    : this.state.isImpactDeleted
                                      ? "Associated Dataset's Impact fields might been deleted or revoked"
                                      : "No records available"}
                              </GridNoRecords>
                              <Column
                                field="selected"
                                locked={true}
                                width="42px"
                                headerSelectionValue={
                                  this.state.finalRiskList.findIndex(
                                    (dataItem) => dataItem.selected === false
                                  ) === -1
                                }
                              />
                              <Column
                                field="organizationUnitName"
                                title="Workstream"
                                width="100px"
                                editable={false}
                                columnMenu={(props) => (
                                  <ColumnMenuFilter
                                    {...props}
                                    getSelectedColumn={this.getSelectedColumn}
                                  />
                                )}
                                headerClassName={this.setClassName(
                                  "organizationUnitName"
                                )}
                              />

                              <Column
                                field="number"
                                title="Risk Number"
                                width="100px"
                                columnMenu={(props) => (
                                  <ColumnMenuFilter
                                    {...props}
                                    getSelectedColumn={this.getSelectedColumn}
                                  />
                                )}
                                headerClassName={this.setClassName("number")}
                              />

                              <Column
                                field="riskTitle"
                                title="Risk Title*"
                                width="150px"
                                columnMenu={(props) => (
                                  <ColumnMenuFilter
                                    {...props}
                                    getSelectedColumn={this.getSelectedColumn}
                                  />
                                )}
                                headerClassName={this.setClassName("riskTitle")}
                              />

                              <Column
                                field="isOpportunity"
                                title="T/O"
                                width="100px"
                                cell={(props) =>
                                  props.dataItem.isOpportunity === "Threat" ? (
                                    <td>{props.dataItem.isOpportunity}</td>
                                  ) : (
                                    <td>
                                      <span className="turquoiseBlue">
                                        {props.dataItem.isOpportunity}
                                      </span>
                                    </td>
                                  )
                                }
                                columnMenu={(props) => (
                                  <ColumnMenuCheckboxFilter
                                    {...props}
                                    data={this.state.finalRiskList}
                                    getSelectedColumn={this.getSelectedColumn}
                                  />
                                )}
                                headerClassName={this.setClassName("isOpportunity")}
                              />
                              <Column
                                field="name"
                                title="Risk Description"
                                width="150px"
                                editable={false}
                                cell={(props) => (
                                  <RiskDescriptionCell
                                    {...props}
                                    onEditCell={this.onEditCell}
                                  />
                                )}
                                columnMenu={(props) => (
                                  <ColumnMenuFilter
                                    {...props}
                                    getSelectedColumn={this.getSelectedColumn}
                                  />
                                )}
                                headerClassName={this.setClassName("name")}
                              />
                              {/* {this.getsortedrisklist()} */}
                              <Column
                                field="riskTypeNames"
                                title="Risk Type"
                                width="150px"
                                cell={this.viewMultiselectColsRiskType}
                                columnMenu={(props) => (
                                  <SearchMenu
                                    {...props}
                                    existingFilter={this.state.existingFilter}
                                    data={this.state.riskTypemaster}
                                    filterChangeV={this.filterChangeV}
                                    clearFilter={this.clearFilter}
                                  />
                                )}
                                headerClassName={this.setClassName("riskTypeNames")}
                              />
                              <Column
                                field="mitigationCount"
                                title="Action Count"
                                width="80px"
                                filter={"numeric"}
                                columnMenu={(props) => (
                                  <ColumnMenuFilter
                                    {...props}
                                    getSelectedColumn={this.getSelectedColumn}
                                  />
                                )}
                                headerClassName={this.setClassName("mitigationCount")}
                              />
                              {this.state.dropdownColumns}
                              <Column
                                field="cause"
                                title="Cause"
                                width="100px"
                                editable={false}
                                cell={(props) => (
                                  <RiskCauseCell
                                    {...props}
                                    onEditCell={this.onEditCell}
                                  />
                                )}
                                columnMenu={(props) => (
                                  <ColumnMenuFilter
                                    {...props}
                                    getSelectedColumn={this.getSelectedColumn}
                                  />
                                )}
                                headerClassName={this.setClassName("cause")}
                              />
                              <Column
                                field="existingControl"
                                title="Existing Control"
                                width="100px"
                                editable={false}
                                cell={(props) => (
                                  <ExistingControlCell
                                    {...props}
                                    onEditCell={this.onEditCell}
                                  />
                                )}
                                columnMenu={(props) => (
                                  <ColumnMenuFilter
                                    {...props}
                                    getSelectedColumn={this.getSelectedColumn}
                                  />
                                )}
                                headerClassName={this.setClassName("existingControl")}
                              />
                              <Column
                                field="frequency"
                                title="Pre-Probability (%)"
                                width="80px"
                                filter={"numeric"}
                                columnMenu={(props) => (
                                  <ColumnMenuFilter
                                    {...props}
                                    getSelectedColumn={this.getSelectedColumn}
                                  />
                                )}
                                headerClassName={this.setClassName("frequency")}
                              />

                              <Column
                                field="currentProbability"
                                title="Current Probability (%)"
                                filter={"numeric"}
                                width="80px"
                                editable={false}
                                cell={(props) => (
                                  <td>
                                    <span className="turquoiseBlue">
                                      {props.dataItem.currentProbability}
                                    </span>
                                  </td>
                                )}
                                columnMenu={(props) => (
                                  <ColumnMenuFilter
                                    {...props}
                                    getSelectedColumn={this.getSelectedColumn}
                                  />
                                )}
                                headerClassName={this.setClassName("currentProbability")}
                              />
                              <Column
                                field="reductionProbability"
                                title="Post-Probability (%)"
                                width="75px"
                                editable={false}
                                cell={(props) => (
                                  <td>
                                    <span className="yellowCell">
                                      {props.dataItem.reductionProbability}
                                    </span>
                                  </td>
                                )}
                                filter={"numeric"}
                                columnMenu={(props) => (
                                  <ColumnMenuFilter
                                    {...props}
                                    getSelectedColumn={this.getSelectedColumn}
                                  />
                                )}
                                headerClassName={this.setClassName(
                                  "reductionProbability"
                                )}
                              />
                              <Column
                                field="pre"
                                title="pre"
                                width="75px"
                                sortable={false}
                                editable={false}
                                cell={(props) => (
                                  <PrePostComponenant
                                    {...props}
                                    onEditCell={this.onEditCell}
                                    HeatMapConfigDataOpportunity={
                                      this.state.HeatMapConfigDataOpportunity
                                    }
                                    HeatMapConfigDataThreat={
                                      this.state.HeatMapConfigDataThreat
                                    }
                                    dynamicHeatmapProbabilityRange={
                                      this.state.dynamicHeatmapProbabilityRange
                                    }
                                  />
                                )}
                              />
                              <Column
                                field="current"
                                title="current"
                                width="75px"
                                sortable={false}
                                editable={false}
                                cell={(props) => (
                                  <PrePostComponenant
                                    {...props}
                                    onEditCell={this.onEditCell}
                                    HeatMapConfigDataOpportunity={
                                      this.state.HeatMapConfigDataOpportunity
                                    }
                                    HeatMapConfigDataThreat={
                                      this.state.HeatMapConfigDataThreat
                                    }
                                    dynamicHeatmapProbabilityRange={
                                      this.state.dynamicHeatmapProbabilityRange
                                    }
                                  />
                                )}
                              />
                              <Column
                                field="post"
                                title="post"
                                width="75px"
                                editable={false}
                                sortable={false}
                                cell={(props) => (
                                  <PrePostComponenant
                                    {...props}
                                    onEditCell={this.onEditCell}
                                    HeatMapConfigDataOpportunity={
                                      this.state.HeatMapConfigDataOpportunity
                                    }
                                    HeatMapConfigDataThreat={
                                      this.state.HeatMapConfigDataThreat
                                    }
                                    dynamicHeatmapProbabilityRange={
                                      this.state.dynamicHeatmapProbabilityRange
                                    }
                                  />
                                )}
                              />
                              {/* <Column
                      field="overAll"
                      title="OverAll Impact"
                      width="100px"
                      editable={false}
                      sortable={false}
                      cell={(props) => (
                        <OverallComponenant
                          {...props}
                          onEditCell={this.onEditCell}
                        />
                      )}
                    /> */}
                              {/* New  */}

                              <Column
                                field="preRiskScore"
                                title="Risk Score (Pre)"
                                filter={"numeric"}
                                width="80px"
                                editable={false}
                                columnMenu={(props) => (
                                  <ColumnMenuFilter
                                    {...props}
                                    getSelectedColumn={this.getSelectedColumn}
                                  />
                                )}
                                headerClassName={this.setClassName("preRiskScore")}
                              />

                              {isPrime && (
                                <Column
                                  field="preWeightedRiskScore"
                                  title="Prime Risk Score (Pre)"
                                  filter={"numeric"}
                                  width="80px"
                                  editable={false}
                                  columnMenu={(props) => (
                                    <ColumnMenuFilter
                                      {...props}
                                      getSelectedColumn={this.getSelectedColumn}
                                    />
                                  )}
                                  headerClassName={this.setClassName(
                                    "preWeightedRiskScore"
                                  )}
                                />
                              )}

                              <Column
                                field="currentRiskScore"
                                title="Risk Score (Current)"
                                filter={"numeric"}
                                width="80px"
                                editable={false}
                                cell={(props) => (
                                  <td>
                                    <span className="turquoiseBlue">
                                      {props.dataItem.currentRiskScore}
                                    </span>
                                  </td>
                                )}
                                columnMenu={(props) => (
                                  <ColumnMenuFilter
                                    {...props}
                                    getSelectedColumn={this.getSelectedColumn}
                                  />
                                )}
                                headerClassName={this.setClassName("currentRiskScore")}
                              />

                              {isPrime && (
                                <Column
                                  field="currentWeightedRiskScore"
                                  title="Prime Risk Score (Current)"
                                  filter={"numeric"}
                                  width="80px"
                                  editable={false}
                                  columnMenu={(props) => (
                                    <ColumnMenuFilter
                                      {...props}
                                      getSelectedColumn={this.getSelectedColumn}
                                    />
                                  )}
                                  headerClassName={this.setClassName(
                                    "currentWeightedRiskScore"
                                  )}
                                  cell={(props) => (
                                    <td>
                                      <span className="turquoiseBlue">
                                        {props.dataItem.currentWeightedRiskScore}
                                      </span>
                                    </td>
                                  )}
                                />
                              )}

                              <Column
                                field="postRiskScore"
                                title="Risk Score (Post)"
                                filter={"numeric"}
                                width="80px"
                                editable={false}
                                columnMenu={(props) => (
                                  <ColumnMenuFilter
                                    {...props}
                                    getSelectedColumn={this.getSelectedColumn}
                                  />
                                )}
                                headerClassName={this.setClassName("postRiskScore")}
                                cell={(props) => (
                                  <td>
                                    <span className="yellowCell">
                                      {props.dataItem.postRiskScore}
                                    </span>
                                  </td>
                                )}
                              />

                              {isPrime && (
                                <Column
                                  field="postWeightedRiskScore"
                                  title="Prime Risk Score (Post)"
                                  filter={"numeric"}
                                  width="80px"
                                  editable={false}
                                  columnMenu={(props) => (
                                    <ColumnMenuFilter
                                      {...props}
                                      getSelectedColumn={this.getSelectedColumn}
                                    />
                                  )}
                                  headerClassName={this.setClassName(
                                    "postWeightedRiskScore"
                                  )}
                                  cell={(props) => (
                                    <td>
                                      <span className="yellowCell">
                                        {props.dataItem.postWeightedRiskScore}
                                      </span>
                                    </td>
                                  )}
                                />
                              )}
                              {/* End  */}
                              {this.state.impactColumns}
                              <Column
                                field="impactComments"
                                title="Consequences"
                                width="120px"
                                editable={false}
                                columnMenu={(props) => (
                                  <ColumnMenuFilter
                                    {...props}
                                    getSelectedColumn={this.getSelectedColumn}
                                  />
                                )}
                                headerClassName={this.setClassName("impactComments")}
                              />
                              <Column
                                field="progress"
                                title="Progress Status"
                                width="120px"
                                editable={false}
                                cell={(props) => (
                                  <td title={props.dataItem.progress}>
                                    <span
                                      onClick={() => this.progressHistory(props.dataItem)}
                                    >
                                      {props.dataItem.progress}
                                    </span>
                                  </td>
                                )}
                              />
                              <Column
                                field="proximityDate"
                                title="Proximity Date"
                                width="120px"
                                editor="date"
                                filter={"date"}
                                editable={false}
                                format="{0:dd-MMM-yyyy}"
                                columnMenu={(props) => (
                                  <ColumnMenuFilter
                                    {...props}
                                    getSelectedColumn={this.getSelectedColumn}
                                  />
                                )}
                                headerClassName={this.setClassName("proximityDate")}
                              />
                              <Column
                                field="owner"
                                title="Owner"
                                width="120px"
                                editable={false}
                                columnMenu={(props) => (
                                  <ColumnMenuCheckboxFilter
                                    {...props}
                                    data={this.state.finalRiskList}
                                    getSelectedColumn={this.getSelectedColumn}
                                  />
                                )}
                                headerClassName={this.setClassName("owner")}
                              />
                              <Column
                                field="riskFieldsCompletion"
                                title="% of fields completed"
                                width="120px"
                                editable={false}
                                filter={"numeric"}
                                columnMenu={(props) => (
                                  <ColumnMenuFilter
                                    {...props}
                                    getSelectedColumn={this.getSelectedColumn}
                                  />
                                )}
                                headerClassName={this.setClassName(
                                  "riskFieldsCompletion"
                                )}
                              />

                              <Column
                                field="createdDate"
                                title="Created Date"
                                filter={"date"}
                                format="{0:dd-MMM-yyyy}"
                                width="120px"
                                editable={false}
                                columnMenu={(props) => (
                                  <ColumnMenuFilter
                                    {...props}
                                    getSelectedColumn={this.getSelectedColumn}
                                  />
                                )}
                                headerClassName={this.setClassName("createdDate")}
                              />
                              <Column
                                field="createdByName"
                                title="Created By"
                                width="120px"
                                editable={false}
                                columnMenu={(props) => (
                                  <ColumnMenuCheckboxFilter
                                    {...props}
                                    data={this.state.finalRiskList}
                                    getSelectedColumn={this.getSelectedColumn}
                                  />
                                )}
                                headerClassName={this.setClassName("createdByName")}
                              />
                              <Column
                                field="updatedDate"
                                title="updated Date"
                                width="120px"
                                editor="date"
                                filter={"date"}
                                editable={false}
                                format="{0:dd-MMM-yyyy}"
                                columnMenu={(props) => (
                                  <ColumnMenuFilter
                                    {...props}
                                    getSelectedColumn={this.getSelectedColumn}
                                  />
                                )}
                                headerClassName={this.setClassName("updatedDate")}
                              />
                              <Column
                                field="updatedBy"
                                title="updated By"
                                width="120px"
                                editable={false}
                                columnMenu={(props) => (
                                  <ColumnMenuCheckboxFilter
                                    {...props}
                                    data={this.state.finalRiskList}
                                    getSelectedColumn={this.getSelectedColumn}
                                  />
                                )}
                                headerClassName={this.setClassName("updatedBy")}
                              />
                              <Column
                                field="isClosed"
                                title="Status"
                                width="70px"
                                // editor="boolean"
                                editable={false}
                                columnMenu={(props) => (
                                  <ColumnMenuCheckboxFilter
                                    {...props}
                                    data={this.state.finalRiskList}
                                    getSelectedColumn={this.getSelectedColumn}
                                  />
                                )}
                                headerClassName={this.setClassName("isClosed")}
                              />
                              <Column
                                field="closedDate"
                                title="closed Date"
                                width="120px"
                                editor="date"
                                filter={"date"}
                                editable={false}
                                format="{0:dd-MMM-yyyy}"
                                columnMenu={(props) => (
                                  <ColumnMenuFilter
                                    {...props}
                                    getSelectedColumn={this.getSelectedColumn}
                                  />
                                )}
                                headerClassName={this.setClassName("closedDate")}
                              />
                            </Grid>
                          </div>
                        </div>
                      </>
                    )}

                  {this.state.selected === 0 &&
                    (this.state.viewType === "ACTION" ||
                      this.state.viewType === "ALL") && (
                      <>
                        {this.state.isDatasetMode &&
                          <div className="createDashboardDialog">
                            {this.renderTopXDataset("ACTION")}
                          </div>
                        }

                        <div className="gbox marginBtm10" id="rw-tab-header">
                          <div className="header">
                            <h5>
                              Actions
                            </h5>
                            <ul>
                              {this.state.OrgUnitIds &&
                                this.state.OrgUnitIds.length > 0 &&
                                this.state.isDatasetMode === false && (
                                  <li onClick={() => this.startCreateDataset("ACTION")}>
                                    <button> 
                                      Create Action Dataset
                                    </button>
                                  </li>
                                )}
                            </ul>
                          </div>
                          <div className="tblCont riskRegister dataGrids reportsGrid">
                            <MitigationViewSelection
                              {...this.props}
                              mitigationData={this.state.mitigationData}
                              mitigationDataTemp={this.state.mitigationDataTemp}
                              mitigationFilterQuery={this.mitigationFilterQuery}
                              getSelectedIds={this.getSelectedIds}
                              customFieldsmaster={
                                this.state.customFieldsmasterMiti
                                  ? this.state.customFieldsmasterMiti
                                  : []
                              }
                              riskTypemaster={
                                this.state.riskTypemasterMiti
                                  ? this.state.riskTypemasterMiti
                                  : []
                              }
                              editFlag={this.state.editFlag}
                              isCustomFieldDeleted={this.state.isCustomFieldDeleted}
                              isImpactDeleted={this.state.isImpactDeleted}
                              ref="childAction"
                              filteredRiskIds={this.state.filteredRiskIds}
                              topXConfig={this.getTopXConfig("ACTION")}
                              applyTopXFilter={this.applyTopXFilter}
                            ></MitigationViewSelection>
                          </div>
                        </div>
                      </>
                    )}
                
                
                  {this.state.selected === 1 &&
                    (this.state.viewType === "TASK" || this.state.viewType === "ALL" || this.state.viewType === "SUBTASK") &&
                    secureLocalStorage.getItem("isTasksModuleEnabled") === true && (
                      <div className="gbox marginBtm10" id="rw-tab-header">
                        <div className="header">
                          <h5>
                            Tasks
                          </h5>
                          <ul>
                            {this.state.OrgUnitIds &&
                              this.state.OrgUnitIds.length > 0 && this.state.isDatasetMode === false && (
                                <li onClick={() => this.startCreateDataset("TASK")}>
                                  <button>
                                    Create Task Dataset
                                  </button>
                                </li>
                              )}
                          </ul>
                        </div>
                        <div className="tblCont riskRegister dataGrids reportsGrid">
                          <TaskDataset
                            {...this.props}
                            taskDataList={this.state.taskDataList}
                            taskDataListTemp={this.state.taskDataList}
                            taskFilterQueryGenerator={this.taskFilterQueryGenerator}
                            getTaskSelectedIds={this.getTaskSelectedIds}
                            customFieldsmaster={
                              this.state.customFieldsmasterMiti
                                ? this.state.customFieldsmasterMiti
                                : []
                            }
                            editFlag={this.state.editFlag}
                            workstreamIdpopulation={this.workstreamIdpopulation}
                            ref="childTask"
                            topXConfig={this.getTopXConfig("TASK")}
                            applyTopXFilter={this.applyTopXFilter}
                            onTaskFilterChange={this.handleFilteredTaskIds}
                          ></TaskDataset>
                        </div>
                      </div>
                    )}

                  {this.state.selected === 1 && (this.state.viewType === "SUBTASK" || this.state.viewType === "ALL") && secureLocalStorage.getItem("isTasksModuleEnabled") === true && (
                    <div className="gbox marginBtm10" id="rw-tab-header">
                      <div className="header">
                        <h5>
                          Activities
                        </h5>
                        <ul>
                          {this.state.OrgUnitIds &&
                            this.state.OrgUnitIds.length > 0 && this.state.isDatasetMode === false && (
                              <li onClick={() => this.startCreateDataset("SUBTASK")}>
                                <button>
                                  Create Activity Dataset
                                </button>
                              </li>
                            )}
                        </ul>
                      </div>
                      {this.state.isDatasetMode && (
                        <div className="createDashboardDialog">
                          {this.renderTopXDataset("Activity")}
                        </div>
                      )}
                      <div className="tblCont riskRegister dataGrids reportsGrid">
                        <SubTaskDataset
                          {...this.props}
                          taskDataList={this.state.subTaskDataList}
                          taskDataListTemp={this.state.subTaskDataList}
                          subTaskFilterQueryGenerator={
                            this.subTaskFilterQueryGenerator
                          }
                          getSubTaskSelectedIds={this.getSubTaskSelectedIds}
                          customFieldsmaster={
                            this.state.customFieldsmasterMiti
                              ? this.state.customFieldsmasterMiti
                              : []
                          }
                          editFlag={this.state.editFlag}
                          isCustomFieldDeleted={this.state.isCustomFieldDeleted}
                          isImpactDeleted={this.state.isImpactDeleted}
                          workstreamIdpopulation={this.workstreamIdpopulation}
                          ref="childSubTask"
                          filteredTaskIds={this.state.filteredTaskIds}
                          topXConfig={this.getTopXConfig("ACTIVITY")}
                          applyTopXFilter={this.applyTopXFilter}
                        ></SubTaskDataset>
                      </div>
                    </div>
                  )}
                  </div>
                
              </div>
            </div>
          </div>
        </div>
        <Dialog
          open={false}
          onClose={this.state.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <div name="dashboardname">
            <div className="createDashboardDialog">
              <h4>
                {" "}
                {this.state.editFlag ? "Update Dataset" : "Create Dataset"}
              </h4>
              {this.state.loader ? (
                <span className="MatTableSpinner">
                  <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
                </span>
              ) : null}
              <div className="row">
                <div className="col-xs-12 col-sm-12">
                  <div className="formControl">
                    <label>View Name *</label>
                    <input
                      type="text"
                      required
                      value={this.state.Name}
                      onChange={(e) => this.handleViewName(e)}
                    />
                  </div>
                  {/* <small>Alphabets only</small> */}
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12 col-sm-12">
                  <div className="formControl">
                    <label>Description</label>
                    <input
                      type="text"
                      // required
                      value={this.state.description}
                      onChange={(e) =>
                        this.setState({
                          ...this.state,
                          description: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>

              {this.activateFilterDataset ? (
                <div className="accessSpecifier">
                  <RadioGroup
                    aria-label="btn"
                    name="btn1"
                    value={this.state.date_impact}
                    onChange={(e) =>
                      this.setState({
                        ...this.state,
                        date_impact: e.target.value,
                      })
                    }
                  >
                    <FormControlLabel
                      value="Date"
                      control={<Radio />}
                      label="Date Selection"
                    />

                    <FormControlLabel
                      value="Impact"
                      control={<Radio />}
                      label="Value Selection"
                    />
                    <FormControlLabel
                      value="None"
                      control={<Radio />}
                      label="None"
                    />
                  </RadioGroup>
                </div>
              ) : (
                ""
              )}

              {this.state.date_impact == "Impact" &&
              this.activateFilterDataset === true ? (
                <div className="row">
                  <div className="col-xs-3 col-sm-3 ">
                    <div class="formControl2">
                      <label>Top/Bottom *</label>
                      <div className="dBlockCont">
                        <DropDownList
                          data={this.state.topBottomList}
                          value={this.state.actSelectedTopBottom}
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              actSelectedTopBottom: e.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-xs-3 col-sm-3">
                    <div class="formControl4">
                      <label>Number *</label>
                      <div className="dBlockCont">
                        <input
                          type="text"
                          value={this.state.actSelectedNumber}
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              actSelectedNumber: e.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-3 col-sm-3">
                    <div class="formControl1">
                      <label>Field *</label>
                      <div className="dBlockCont">
                        <DropDownList
                          data={this.state.fieldList}
                          value={this.state.actSelectedField}
                          textField="displayName"
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              actSelectedField: e.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
              {this.state.date_impact == "Date" &&
              this.activateFilterDataset === true ? (
                <div className="row">
                  <div>
                    <div className="col-xs-3 col-sm-3 ">
                      <div class="formControl2">
                        <label>Mode *</label>
                        <div className="dBlockCont">
                          <DropDownList
                            data={this.state.Mode}
                            value={this.state.mode_value}
                            onChange={(e) => {
                              if (
                                e.target.value === "Forward" &&
                                this.state.datefield_value &&
                                this.state.datefield_value.name ===
                                  "Updated Date"
                              ) {
                                this.setState({
                                  ...this.state,
                                  datefield_value: null,
                                  mode_value: e.target.value,
                                });
                              } else {
                                this.setState({
                                  ...this.state,
                                  mode_value: e.target.value,
                                });
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    {/* // dynamicdatset modification */}
                    <div className="col-xs-3 col-sm-3 ">
                      <div class="formControl4">
                        <label>No.of Days *</label>
                        <input
                          type="text"
                          required
                          value={this.state.days_value}
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              days_value: e.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-3 col-sm-3 ">
                    <div class="formControl1">
                      <label>Date Field *</label>
                      <div className="dBlockCont" style={{ marginLeft: "3px" }}>
                        <DropDownList
                          data={
                            this.state.mode_value === "Forward"
                              ? this.state.dateFieldList.filter(
                                  (element) =>
                                    element.name != "Updated Date" &&
                                    element.name != "Created Date"
                                )
                              : this.state.dateFieldList
                          }
                          value={this.state.datefield_value}
                          textField="displayName"
                          onChange={(e) => {
                            this.setState({
                              ...this.state,
                              datefield_value: e.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}

              <div className="btnCont">
                <button
                  className="btnGreen"
                  type="button"
                  // dynamicdatset modification
                  disabled={this.getSubmitValidations()}
                  onClick={this.saveQuery}
                >
                  {this.state.editFlag ? "Update" : "Create"}
                </button>

                <button
                  className="btnRed"
                  type="button"
                  onClick={this.handleClose}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </Dialog>

        <Popup
          show={this.state.openDeleteModelFlagView}
          popupClass={"popup-content"}
        >
          {this.state.loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}
          <div className="deleteModelCont">
            <h3>Are you sure you want to delete this dataset?</h3>
            <div className="btnCont">
              <button
                onClick={() => this.removeView()}
                className="deleteBtn"
                type="button"
              >
                Delete
              </button>
              <button
                onClick={this.closeDeletePopup}
                className="cancelBtn"
                type="button"
              >
                Cancel
              </button>
            </div>
          </div>
        </Popup>

        <Popup
          show={this.state.openWidgetCreatePopup}
          popupClass={"popup-content"}
        >
          {this.state.loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}
          <div className="reportsPopup">
            <h3>
              {this.state.viewFlag === "MITI"
                ? "Create Action Report"
                : "Create Risk Report"}
            </h3>
            <div className="formControl">
              <label>
                {" "}
                {this.state.viewFlag === "MITI"
                  ? "Action Report Name *"
                  : "Risk Report Name *"}
              </label>
              <input
                type="text"
                autoComplete="off"
                value={this.state.reportName}
                onBlur={(e) => this.isExistName(e)}
                onChange={(e) => {
                  this.setState({
                    ...this.state,
                    reportName: e.target.value,
                  });
                  if (e.target.value) {
                    this.setState((prevState) => ({
                      widgetError: {
                        ...prevState.widgetError,
                        widgetName: false,
                      },
                    }));
                  } else {
                    this.setState((prevState) => ({
                      widgetError: {
                        ...prevState.widgetError,
                        widgetName: true,
                      },
                    }));
                  }
                }}
              />
              {this.state.widgetError && this.state.widgetError.widgetName ? (
                <span className="errMsg">Report name is required</span>
              ) : (
                ""
              )}
              {this.state.isNameExist && (
                <span className="errMsg">Duplicate Report Name</span>
              )}
            </div>
            {this.state.widgetName !== "BURN_DOWN_CHART" &&
            this.state.widgetName != "MONTE_CARLO" &&
            this.state.widgetName !== "TEXT_WIDGET" &&
            this.state.widgetName !== "KPI" &&
            this.state.widgetName !== "DATA" ? (
              <div className="formControl">
                {this.state.widgetName !== "TRENDING_CHART" && (
                  <Checkbox
                    defaultValue={this.state.IsTimestamp}
                    label={"Timestamp"}
                    onChange={this.ToggleTimestamp}
                  />
                )}
                <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                {
                  <Checkbox
                    defaultValue={this.state.isOpportunities}
                    label={"Opportunities"}
                    onChange={(e) => {
                      this.setState({
                        ...this.state,
                        isOpportunities: e.value,
                      });
                    }}
                  />
                }
              </div>
            ) : (
              ""
            )}
            <div className="chartBox formControl">
              <label>Select Chart *</label>
              <ul className={this.state.ActiveId !== null ? "selected" : ""}>
                {this.state.widgetTypeList &&
                  this.state.widgetTypeList.map((item) => (
                    <li
                      onClick={() => this.selectWidget(item)}
                      className={
                        item.widgetTypeId === this.state.ActiveId
                          ? "active"
                          : ""
                      }
                    >
                      <a className="gBox active" href="#">
                        <img
                          src={this.getChatImage(item.image)}
                          height="40"
                          alt="Chart"
                        />
                        <span>
                          {item.displayname === "Kpi"
                            ? item.displayname.toLocaleUpperCase()
                            : item.displayname}
                        </span>
                      </a>
                    </li>
                  ))}
              </ul>
              {this.state.widgetError && this.state.widgetError.widgetChart ? (
                <span className="errMsg">Chart is required</span>
              ) : (
                ""
              )}
            </div>
            <div className="formControl">
              <label>
                {this.state.viewFlag === "MITI"
                  ? "Action Report Title"
                  : " Risk Report Title"}
              </label>
              <input
                value={this.state.title}
                type="text"
                autoComplete="off"
                onChange={(e) => {
                  this.setState({
                    ...this.state,
                    title: e.target.value,
                  });
                }}
              />
            </div>
            <div className="formControl">
              <label>
                {this.state.viewFlag === "MITI"
                  ? "Action Report Description"
                  : "Risk Report Description"}
              </label>
              <input
                value={this.state.description}
                type="text"
                autoComplete="off"
                onChange={(e) => {
                  this.setState({
                    ...this.state,
                    description: e.target.value,
                  });
                }}
              />
            </div>
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12">
                <div class="formControl">
                  <label>Select Dashboard *</label>
                  <div className="dBlockCont">
                    <DropDownList
                      data={this.state.dashboardList}
                      onChange={(e) => {
                        this.setState({
                          ...this.state,
                          dashboard: e.target.value,
                        });
                        if (e.target.value) {
                          this.setState((prevState) => ({
                            widgetError: {
                              ...prevState.widgetError,
                              widgetDashboard: false,
                            },
                          }));
                        } else {
                          this.setState((prevState) => ({
                            widgetError: {
                              ...prevState.widgetError,
                              widgetDashboard: true,
                            },
                          }));
                        }
                      }}
                      value={this.state.dashboard}
                      textField="name"
                    />
                  </div>
                  {this.state.widgetError &&
                  this.state.widgetError.widgetDashboard ? (
                    <span className="errMsg">Dashboard is required</span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {this.state.widgetName !== "TEXT_WIDGET" && (
                <div className="col-xs-12 col-sm-12 col-md-12">
                  <div class="formControl">
                    <label>Dataset *</label>
                    <div className="dBlockCont">
                      <DropDownList
                        data={this.state.datasourceList}
                        onChange={(e) => this.selectDataset(e)}
                        value={this.state.datasource}
                        textField="name"
                      />
                    </div>
                    {this.state.widgetError &&
                    this.state.widgetError.widgetDataSet ? (
                      <span className="errMsg">Data Set is required</span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              )}

              {this.state.widgetName !== "BURN_DOWN_CHART" &&
              this.state.widgetName !== "TEXT_WIDGET" &&
              this.state.widgetName !== "KPI" &&
              this.state.widgetName !== "DATA" ? (
                <>
                  {this.state.widgetName !== "TRENDING_CHART" && (
                    <div className="col-xs-12 col-sm-12 col-md-12">
                      <div class="formControl">
                        {this.state.widgetName === "BAR_CHART" ||
                        this.state.widgetName === "LINE_CHART" ? (
                          <label>
                            X Axis *<small></small>
                          </label>
                        ) : this.state.widgetName === "HEAT_MAP" ||
                          this.state.widgetName === "MONTE_CARLO" ? (
                          <label>
                            Select Impact *<small></small>
                          </label>
                        ) : (
                          <label>
                            Categories *<small></small>
                          </label>
                        )}
                        <div className="dBlockCont">
                          <DropDownList
                            data={this.getImpactListValues()}
                            value={this.state.XAxisValue}
                            disabled={
                              !this.state.widgetName || !this.state.datasource
                            }
                            textField="displayName"
                            onChange={(e) => {
                              this.setState({
                                ...this.state,
                                XAxisValue: e.target.value,
                                YAxisValue: {},
                              });
                              console.log("XAxisValue", this.state.XAxisValue);
                              if (e.target.value) {
                                this.setState((prevState) => ({
                                  widgetError: {
                                    ...prevState.widgetError,
                                    widgetXAxis: false,
                                  },
                                }));
                              } else {
                                this.setState((prevState) => ({
                                  widgetError: {
                                    ...prevState.widgetError,
                                    widgetXAxis: true,
                                  },
                                }));
                              }
                            }}
                          />
                        </div>
                        {this.state.widgetError &&
                        this.state.widgetError.widgetXAxis ? (
                          <span className="errMsg">X-Axis is required</span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  )}

                  <div className="col-xs-12 col-sm-12 col-md-12">
                    <div class="formControl">
                      {this.state.widgetName === "BAR_CHART" ||
                      this.state.widgetName === "LINE_CHART" ||
                      this.state.widgetName === "TRENDING_CHART" ? (
                        <label>
                          Y Axis *<small></small>
                        </label>
                      ) : this.state.widgetName === "HEAT_MAP" ||
                        this.state.widgetName === "MONTE_CARLO" ? (
                        ""
                      ) : (
                        <label>
                          Value *<small></small>
                        </label>
                      )}
                      {this.state.widgetName !== "HEAT_MAP" &&
                      this.state.widgetName != "MONTE_CARLO" ? (
                        <div className="dBlockCont">
                          <DropDownList
                            data={this.getYaxisValue(this.state.XAxisValue)}
                            value={this.state.YAxisValue}
                            textField="displayName"
                            disabled={
                              this.state.widgetName !== "TRENDING_CHART"
                                ? !this.state.XAxisValue ||
                                  Object.keys(this.state.XAxisValue).length == 0
                                : !this.state.widgetName ||
                                  !this.state.datasource
                            }
                            onChange={(e) => {
                              this.setState({
                                ...this.state,
                                YAxisValue: e.target.value,
                              });
                              if (e.target.value) {
                                this.setState((prevState) => ({
                                  widgetError: {
                                    ...prevState.widgetError,
                                    widgetYAxis: false,
                                  },
                                }));
                              } else {
                                this.setState((prevState) => ({
                                  widgetError: {
                                    ...prevState.widgetError,
                                    widgetYAxis: true,
                                  },
                                }));
                              }
                            }}
                          />
                        </div>
                      ) : (
                        ""
                      )}

                      {this.state.widgetError &&
                      this.state.widgetError.widgetYAxis ? (
                        <span className="errMsg">Y-Axis is required</span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
              {this.state.IsTimestamp === true ||
              this.state.widgetName === "TRENDING_CHART" ||
              (this.state.widgetName === "BURN_DOWN_CHART" &&
                this.state.widgetName !== "TEXT_WIDGET" &&
                this.state.widgetName !== "KPI" &&
                this.state.widgetName !== "DATA") ? (
                <div className="col-xs-12 col-sm-12 col-md-12">
                  <div className="formControl">
                    <div className="TimestampHeader">
                      <div className="tsTitle">
                        <span>
                          <img src={Images.HISTORY} alt="History" width="14" />
                        </span>
                        {this.state.IsTimestamp === true ? (
                          <h3>Timestamp</h3>
                        ) : (
                          ""
                        )}
                      </div>
                      <ul>
                        <li>
                          {this.state.IsTimestamp === true ? (
                            <label>Snapshot 1 *</label>
                          ) : (
                            <label>Start Date *</label>
                          )}
                          {this.state.widgetName === "TRENDING_CHART" ? (
                            <DatePicker
                              max={new Date()}
                              format="dd-MMM-yyyy"
                              defaultValue={this.state.startDate}
                              formatPlaceholder="Snapchat11"
                              onChange={(e) => {
                                this.setState({
                                  ...this.state,
                                  startDate: e.target.value,
                                });
                              }}
                            />
                          ) : (
                            <DatePicker
                              // max={new Date()}
                              format="dd-MMM-yyyy"
                              defaultValue={this.state.startDate}
                              formatPlaceholder="Snapchat11"
                              onChange={(e) => {
                                this.setState({
                                  ...this.state,
                                  startDate: e.target.value,
                                });
                              }}
                            />
                          )}
                        </li>
                        <li>
                          {this.state.IsTimestamp === true ? (
                            <label>Snapshot 2 *</label>
                          ) : (
                            <label>End Date *</label>
                          )}
                          {this.state.widgetName === "TRENDING_CHART" ? (
                            <DatePicker
                              max={new Date()}
                              min={
                                this.state.startDate
                                  ? this.state.startDate
                                  : new Date()
                              }
                              format="dd-MMM-yyyy"
                              formatPlaceholder="Snapchat2"
                              defaultValue={this.state.endDate}
                              onChange={(e) => {
                                this.setState({
                                  ...this.state,
                                  endDate: e.target.value,
                                });
                              }}
                            />
                          ) : (
                            <DatePicker
                              format="dd-MMM-yyyy"
                              formatPlaceholder="Snapchat2"
                              defaultValue={this.state.endDate}
                              onChange={(e) => {
                                this.setState({
                                  ...this.state,
                                  endDate: e.target.value,
                                });
                              }}
                            />
                          )}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="d-flex justify-content-end">
              <button
                className="btnGreen"
                type="button"
                onClick={this.saveWidget}
              >
                Create Report
              </button>
              <button
                className="btnRed"
                type="button"
                onClick={this.createWidgetdClose}
              >
                Cancel
              </button>
            </div>
          </div>
        </Popup>
        <Popup
          show={this.state.progressStatusFlag}
          popupClass={"popup-content popup-wrapper"}
        >
          <div className="deleteModelCont stackHolderSelection">
            <label className="fieldLabel">Progress History</label>
            <div className="commentsHistory">
              <ul className="comments">
                {this.state.riskImpactComments &&
                  this.state.riskImpactComments.map((item) => (
                    <li>
                      <p>{item.riskComment}</p>
                      <small>
                        Date:
                        {moment(new Date(item.createdDate)).format(
                          "DD-MMM-yyyy HH:mm:ss"
                        )}
                      </small>{" "}
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                      <small>Entered by:{item.userName}</small>
                    </li>
                  ))}
              </ul>
            </div>
            <div className="progressBtn">
              <button
                onClick={this.closeProgressHistoryPopup}
                className="redbtn"
                type="button"
                style={{ "margin-left": "700px", "margin-bottom": "15px" }}
              >
                Cancel
              </button>
            </div>
          </div>
        </Popup>

        <Popup show={this.state.showAddToCart} popupClass={"popup-content"}>
          <AddToCart
            {...this.props}
            closeAddToCart={() => this.closeAddToCart()}
            cartViewDetailsId={this.state.cartViewDetails.id}
            cartViewType={this.state.cartViewType}
          />
        </Popup>
      </div>
    );
  }
  onItemClick = (event) => {
    event.item.selected = !event.item.selected;
    this.forceUpdate();
  };
}
export default connect()(Datasets);
